import { createContext, useContext, useEffect, useMemo, useState } from "react";

export const LANGS = [
  ["fr", "FR"],
  ["en", "EN"],
  ["de", "DE"],
  ["es", "ES"],
  ["it", "IT"],
];

const UI = {
  fr: {
    "months": ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
    "dow": ["L", "M", "M", "J", "V", "S", "D"],
    "cal.loading": "chargement",
    "cal.selection": "Sélection",
    "cal.included": "Nuits incluses",
    "cal.unavailable": "Indisponible",
    "nav.gites": "Nos gîtes",
    "nav.reviews": "Avis",
    "nav.contact": "Contact",
    "nav.book": "Réserver",
    "nav.soon": "Prochainement",
    "footer.tagline": "Deux gîtes dans une ferme comtoise du Haut-Doubs, à quelques minutes de la frontière suisse. Le Chalet est classé meublé de tourisme 4 étoiles.",
    "footer.find": "Nous trouver",
    "footer.domain": "Le domaine",
    "footer.chalet": "Le Chalet · 6 personnes",
    "footer.ferme": "La Ferme · 4 personnes",
    "footer.both": "Les deux gîtes · 10 personnes",
    "footer.cgv": "CGV",
    "footer.cancel": "Politique d'annulation",
    "footer.legal": "Mentions légales",
    "footer.privacy": "Confidentialité",
    "footer.owner": "Espace propriétaire",
    "footer.bottom": "La Ferme Comtoise — Le Chalet, meublé de tourisme classé 4★ — Paiement sécurisé Stripe",
    "home.house": "La maison",
    "home.title": "Une ferme comtoise typique du Haut-Doubs des années 1800",
    "home.p1": "Bienvenue au cœur du Haut-Doubs, dans une authentique ferme comtoise à seulement quinze minutes de la Suisse. Évadez-vous dans nos gîtes, lieux privilégiés pour se retrouver, se ressourcer et profiter pleinement de la beauté de la région.",
    "home.p2a": "Nos ",
    "home.p2b": "deux appartements",
    "home.p2c": " peuvent également être loués ensemble pour accueillir jusqu'à dix personnes, dans un cadre idéal pour partager des moments privilégiés en famille ou entre amis.",
    "home.activities": "Exemple d'activités pour votre séjour franco-suisse",
    "act.bike": "VTT",
    "act.ski": "Ski",
    "act.snowshoe": "Raquettes",
    "act.hike": "Randonnées",
    "act.museum": "Musées de l'horlogerie",
    "act.absinthe": "La route de l'absinthe",
    "home.lodgings": "Nos logements",
    "home.rentBoth": "Louer les deux gîtes en même temps",
    "home.details": "Photos, infos & calendrier",
    "home.detailsSoon": "Bientôt disponible · en savoir plus",
    "unit.pers": "pers.",
    "unit.rooms": "ch.",
    "unit.baths": "sdb",
    "gite.loading": "Chargement…",
    "gite.notfound": "Gîte introuvable.",
    "gite.back": "Retour",
    "gite.soonBadge": "Prochainement",
    "gite.upcoming": "À venir",
    "gite.giteFor": "Gîte {n} personnes",
    "gite.bookThis": "Réserver ce gîte",
    "gite.lodging": "Le logement",
    "gite.travelers": "{n} voyageurs",
    "gite.bedsLine": "{r} chambres · {b} lits",
    "gite.bathroom": "{n} salle de bain",
    "gite.amenities": "Équipements",
    "gite.good2know": "Bon à savoir",
    "gite.gallery": "Galerie",
    "gite.galleryWait": "Les aménagements sont en cours : les photos seront publiées dès l'ouverture.",
    "gite.availability": "Disponibilités & tarifs",
    "gite.calendar": "Calendrier",
    "gite.from": "À partir de",
    "gite.perNight": " / nuit",
    "gite.priceNote": "Tarifs selon les dates – consultez le calendrier pour connaître le prix de votre séjour. Ménage obligatoire : 40 € jusqu'à 2 nuits, 60 € à partir de 3 nuits.",
    "gite.rates": "Tarifs selon les dates",
    "book.cgvAccept": "J'ai lu et j'accepte les conditions générales de vente et la politique d'annulation.",
    "book.cgvLink": "CGV",
    "book.cancelLink": "politique d'annulation",
    "book.cgvRequired": "Merci d'accepter les CGV avant de continuer",
    "book.deposit": "Caution (empreinte bancaire, sans débit)",
    "book.recapTitle": "À régler lors de la confirmation",
    "book.payObligation": "Continuer vers le paiement sécurisé (obligation de paiement)",
    "gite.opening": "Ouverture",
    "gite.soonAvailable": "Bientôt disponible",
    "gite.openNote": "Les tarifs et les photos seront publiés à l'ouverture. Laissez-nous votre email pour être prévenu en priorité.",
    "gite.notifyMe": "Être prévenu de l'ouverture",
    "gite.secure": "Paiement sécurisé par Stripe",
    "gite.towels": "Linge de toilette fourni",
    "gite.checkin": "Arrivée dès 16 h · départ avant 11 h",
    "gite.photoAlt": "Photo du gîte",
    "book.eyebrow": "Réservation en ligne",
    "book.title": "Choisissez vos dates",
    "book.intro": "Les nuits barrées sont déjà réservées. La réservation n'est pas instantanée : nous validons chaque demande sous 48 heures, le paiement intervient à ce moment-là.",
    "book.sentTitle": "Demande envoyée",
    "book.sentText": "Merci ! Nous vous redirigeons vers le paiement sécurisé Stripe pour enregistrer votre carte. Aucun débit n'est effectué : nous validons votre demande sous 48 heures et le montant n'est encaissé qu'à ce moment-là. En cas de refus, l'empreinte est libérée immédiatement.",
    "book.details": "Vos coordonnées",
    "book.name": "Nom complet *",
    "book.email": "Email *",
    "book.phone": "Téléphone",
    "book.guests": "Nombre de personnes *",
    "book.person": "personne",
    "book.persons": "personnes",
    "book.adults": "Nombre de personnes majeures *",
    "book.adultsNote": "Base de calcul de la taxe de séjour (mineurs exonérés)",
    "book.adultsAuto": "Calculé d'après la liste des voyageurs ci-dessous. Base de calcul de la taxe de séjour (mineurs exonérés).",
    "book.purpose": "Motif du séjour (facultatif)",
    "book.firstName": "Prénom *",
    "book.lastName": "Nom *",
    "book.nationality": "Nationalité *",
    "book.addr1": "Adresse *",
    "book.zip": "Code postal *",
    "book.city": "Ville *",
    "book.country": "Pays *",
    "book.holder": "Titulaire de la réservation",
    "book.occupants": "Autres voyageurs",
    "book.occupantsNote": "Nom, prénom, statut et nationalité de chaque voyageur accompagnant, requis pour le contrat de location.",
    "book.occupant": "Voyageur {n}",
    "book.adult": "Adulte",
    "book.minor": "Mineur",
    "police.eyebrow": "Formalité légale",
    "police.title": "Fiche individuelle de police",
    "police.intro": "La réglementation française impose une fiche individuelle pour chaque voyageur de nationalité étrangère séjournant dans un meublé de tourisme. Merci de la compléter et de la signer le jour de votre arrivée.",
    "police.stay": "{g} · du {a} au {d}",
    "police.lastName": "Nom",
    "police.firstNames": "Prénoms",
    "police.birthDate": "Date de naissance",
    "police.birthPlace": "Lieu de naissance",
    "police.nationality": "Nationalité",
    "police.home": "Domicile habituel",
    "police.mobile": "Téléphone mobile",
    "police.email": "Adresse électronique",
    "police.children": "Enfants de moins de 15 ans accompagnants (noms et prénoms, facultatif)",
    "police.signature": "Signature",
    "police.clear": "Effacer",
    "police.needSignature": "Merci de signer avant d'envoyer la fiche",
    "police.saved": "Fiche enregistrée. Merci !",
    "police.error": "Enregistrement impossible, merci de réessayer",
    "police.unknown": "Cette fiche n'est plus disponible",
    "police.done": "Signée",
    "police.fill": "Remplir",
    "police.send": "Envoyer la fiche",
    "police.saving": "Enregistrement…",
    "police.back": "Retour",
    "police.none": "Aucune fiche n'est requise pour ce séjour.",
    "police.privacy": "Ces informations sont recueillies pour satisfaire à une obligation légale, conservées 6 mois puis supprimées automatiquement, et communiquées uniquement aux services de police ou de gendarmerie sur leur demande.",
    "police.prepare": "Enregistrer mes informations",
    "police.prepareHint": "Vous pouvez préparer vos informations dès maintenant : elles seront conservées et il ne vous restera qu'à signer le jour de votre arrivée, comme l'exige la réglementation.",
    "police.draftSaved": "Informations enregistrées. Il ne reste que la signature, à l'arrivée.",
    "police.prepared": "Préparée — à signer à l'arrivée",
    "police.continue": "Reprendre et signer",
    "faq.title": "Questions fréquentes",
    "faq.q1": "Où se situe La Ferme Comtoise ?",
    "faq.a1": "Au 2 rue de la Gypserie, 25500 Les Fins, dans le Haut-Doubs — à une dizaine de minutes de Morteau et un quart d'heure de la frontière suisse.",
    "faq.q2": "Combien de personnes peuvent séjourner dans Le Chalet ?",
    "faq.a2": "Jusqu'à 6 voyageurs, sur 90 m² : deux chambres et trois lits (un lit queen size dans la première, deux lits doubles dans la seconde).",
    "faq.q3": "Le Chalet est-il classé ?",
    "faq.a3": "Oui, Le Chalet est un meublé de tourisme classé 4 étoiles. La Ferme ne bénéficie d'aucun classement à ce jour et n'est pas encore ouverte à la réservation.",
    "faq.q4": "Peut-on réserver directement sur le site ?",
    "faq.a4": "Oui. Votre demande n'est pas une réservation ferme : votre carte est seulement pré-autorisée, sans débit. Nous répondons sous 48 heures et le montant n'est encaissé qu'après notre accord.",
    "faq.q5": "Quels sont les horaires d'arrivée et de départ ?",
    "faq.a5": "Arrivée à partir de 16 h et départ avant 11 h.",
    "faq.q6": "Le linge de lit et les serviettes sont-ils fournis ?",
    "faq.a6": "Le linge de toilette est fourni et les lits sont préparés avant votre arrivée. Au départ, il vous est simplement demandé de défaire les lits utilisés et de déposer les serviettes utilisées dans la baignoire.",
    "faq.q7": "Quels sont les frais de ménage ?",
    "faq.a7": "40 € pour un séjour de 1 à 2 nuits et 60 € à partir de 3 nuits. Le ménage final normal est assuré par nos soins et compris dans ces frais.",
    "faq.q8": "Comment fonctionne la caution de 350 € ?",
    "faq.a8": "Il s'agit d'une empreinte bancaire, sans débit. Elle n'est prélevable, en tout ou partie, que jusqu'à 7 jours après le départ et uniquement sur justification écrite. En l'absence d'incident, aucun débit n'est effectué.",
    "faq.q9": "Les animaux sont-ils acceptés ?",
    "faq.a9": "Non, les animaux ne sont pas acceptés. Le logement est non-fumeur, les fêtes et soirées sont interdites et le calme est demandé après 22 h.",
    "faq.q10": "Y a-t-il un parking et une arrivée autonome ?",
    "faq.a10": "Oui : deux places de parking gratuites au pied du gîte et un accès autonome par boîte à clés sécurisée, dont le code vous est envoyé par email avant l'arrivée.",
    "faq.q11": "Quelles sont les conditions d'annulation ?",
    "faq.a11": "Remboursement de 100 % à plus de 14 jours de l'arrivée, de 50 % du prix du séjour de 14 à 7 jours (bornes incluses), aucun remboursement du prix du séjour à moins de 7 jours. Les frais de ménage sont remboursés intégralement en cas d'annulation avant l'arrivée. Toute annulation doit être adressée par écrit à contact@lafermecomtoise.com.",
    "book.message": "Message (précisez votre venue)",
    "book.submit": "Envoyer ma demande de réservation",
    "book.sending": "Envoi de la demande…",
    "book.legal": "Aucun débit avant notre accord : votre carte est seulement pré-autorisée. Nous validons sous 48 h ; le montant n'est encaissé qu'à ce moment-là et l'empreinte est libérée en cas de refus.",
    "rev.source": "Avis publié initialement sur {s}",
    "book.stay": "Votre séjour",
    "book.arrival": "Arrivée",
    "book.departure": "Départ",
    "book.nights": "nuits",
    "book.cleaning": "Frais de ménage",
    "book.tax": "Taxe de séjour",
    "book.taxLine": "{r} € × {g} pers. × {n} nuits",
    "book.total": "Total",
    "book.taxNote": "Taxe de séjour de {r} € par nuit et par personne majeure, collectée pour {c}. Ménage obligatoire : 40 € jusqu'à 2 nuits, 60 € à partir de 3 nuits. Caution de {d} par empreinte bancaire, sans débit, prélevable jusqu'à 7 jours après le départ avec justificatif (voir les ",
    "book.taxNoteCgv": "CGV",
    "book.pickDates": "Sélectionnez une date d'arrivée puis de départ dans le calendrier.",
    "book.errNoDates": "Choisissez d'abord vos dates",
    "book.toastSent": "Demande envoyée ! Réponse sous 48 heures.",
    "purpose.holiday": "Vacances",
    "purpose.family": "Week-end en famille",
    "purpose.friends": "Séjour entre amis",
    "purpose.work": "Déplacement professionnel",
    "purpose.ski": "Ski / sports d'hiver",
    "purpose.event": "Événement familial",
    "purpose.other": "Autre",
    "rev.eyebrow": "Retours d'expérience",
    "rev.title": "Ce qu'en disent nos voyageurs",
    "rev.emptyTitle": "Les premiers avis arrivent",
    "rev.emptyText": "La Ferme Comtoise vient d'ouvrir ses portes. Nos premiers hôtes séjournent en ce moment : leurs retours seront publiés ici, sans filtre.",
    "rev.ctaTitle": "Vous avez séjourné chez nous ?",
    "rev.ctaText": "Écrivez-nous, nous publierons votre retour tel quel.",
    "rev.cta": "Laisser un avis",
    "revf.eyebrow": "Votre séjour",
    "revf.title": "Laissez votre avis",
    "revf.intro": "Quelques lignes suffisent. Votre avis sera publié après validation par les propriétaires.",
    "revf.author": "Votre nom *",
    "revf.city": "Ville",
    "revf.rating": "Note",
    "revf.star": "étoile",
    "revf.stars": "étoiles",
    "revf.text": "Votre avis *",
    "revf.submit": "Envoyer mon avis",
    "revf.thanks": "Merci !",
    "revf.thanksText": "Votre avis a bien été transmis. Il sera publié sur le site après relecture par nos soins.",
    "revf.home": "Retour à l'accueil",
    "ct.eyebrow": "Nous écrire",
    "ct.title1": "Une question ?",
    "ct.title2": "Un projet de groupe ?",
    "ct.intro": "Nous répondons personnellement à chaque message, généralement dans la journée.",
    "ct.name": "Nom *",
    "ct.email": "Email *",
    "ct.phone": "Téléphone",
    "ct.subject": "Sujet",
    "ct.message": "Message *",
    "ct.send": "Envoyer le message",
    "ct.sending": "Envoi…",
    "ct.success": "Merci ! Votre message est bien arrivé.",
    "ct.toast": "Message envoyé ! Nous répondons sous 24 h.",
    "ct.address": "Adresse",
    "ct.emailLabel": "Email",
    "ct.checkinout": "Arrivée / départ",
    "ct.checkinoutValue": "Arrivée dès 16 h · Départ avant 11 h",
    "ct.map": "Carte Les Fins",
    "subj.info": "Demande d'information",
    "subj.group": "Réservation de groupe (10 personnes)",
    "subj.avail": "Disponibilités",
    "subj.review": "Laisser un avis",
    "subj.other": "Autre",
    "legal.eyebrow": "Informations légales",
  },
  en: {
    "months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    "dow": ["M", "T", "W", "T", "F", "S", "S"],
    "cal.loading": "loading",
    "cal.selection": "Selection",
    "cal.included": "Nights included",
    "cal.unavailable": "Unavailable",
    "nav.gites": "Our lodgings",
    "nav.reviews": "Reviews",
    "nav.contact": "Contact",
    "nav.book": "Book now",
    "nav.soon": "Coming soon",
    "footer.tagline": "Two holiday lodgings in a traditional Comtois farmhouse in the Haut-Doubs, minutes from the Swiss border. Le Chalet is a 4-star classified holiday rental.",
    "footer.find": "Find us",
    "footer.domain": "The property",
    "footer.chalet": "Le Chalet · 6 guests",
    "footer.ferme": "La Ferme · 4 guests",
    "footer.both": "Both lodgings · 10 guests",
    "footer.cgv": "Terms & conditions",
    "footer.cancel": "Cancellation policy",
    "footer.legal": "Legal notice",
    "footer.privacy": "Privacy",
    "footer.owner": "Owner area",
    "footer.bottom": "La Ferme Comtoise — Le Chalet, 4★ classified holiday rental — Secure payment by Stripe",
    "home.house": "The house",
    "home.title": "A traditional Haut-Doubs farmhouse dating from the 1800s",
    "home.p1": "Welcome to the heart of the Haut-Doubs, in an authentic Comtois farmhouse just fifteen minutes from Switzerland. Escape to our lodgings — ideal places to reconnect, recharge and fully enjoy the beauty of the region.",
    "home.p2a": "Our ",
    "home.p2b": "two apartments",
    "home.p2c": " can also be rented together for up to ten guests — the perfect setting for special moments with family or friends.",
    "home.activities": "A taste of what you can do during your French-Swiss stay",
    "act.bike": "Mountain biking",
    "act.ski": "Skiing",
    "act.snowshoe": "Snowshoeing",
    "act.hike": "Hiking",
    "act.museum": "Watchmaking museums",
    "act.absinthe": "The absinthe route",
    "home.lodgings": "Our lodgings",
    "home.rentBoth": "Rent both lodgings at the same time",
    "home.details": "Photos, details & calendar",
    "home.detailsSoon": "Coming soon · learn more",
    "unit.pers": "guests",
    "unit.rooms": "bdrm",
    "unit.baths": "bath",
    "gite.loading": "Loading…",
    "gite.notfound": "Lodging not found.",
    "gite.back": "Back",
    "gite.soonBadge": "Coming soon",
    "gite.upcoming": "Coming soon",
    "gite.giteFor": "Lodging for {n} guests",
    "gite.bookThis": "Book this lodging",
    "gite.lodging": "The lodging",
    "gite.travelers": "{n} guests",
    "gite.bedsLine": "{r} bedrooms · {b} beds",
    "gite.bathroom": "{n} bathroom",
    "gite.amenities": "Amenities",
    "gite.good2know": "Good to know",
    "gite.gallery": "Gallery",
    "gite.galleryWait": "Fitting out is under way: photos will be published as soon as we open.",
    "gite.availability": "Availability & rates",
    "gite.calendar": "Calendar",
    "gite.from": "From",
    "gite.perNight": " / night",
    "gite.priceNote": "Rates vary by date – check the calendar for the price of your stay. Mandatory cleaning fee: €40 up to 2 nights, €60 from 3 nights.",
    "gite.rates": "Rates vary by date",
    "book.cgvAccept": "I have read and accept the terms of sale and the cancellation policy.",
    "book.cgvLink": "Terms of sale",
    "book.cancelLink": "cancellation policy",
    "book.cgvRequired": "Please accept the terms before continuing",
    "book.deposit": "Security deposit (card hold, no charge)",
    "book.recapTitle": "Payable on confirmation",
    "book.payObligation": "Continue to secure payment (obligation to pay)",
    "gite.opening": "Opening",
    "gite.soonAvailable": "Available soon",
    "gite.openNote": "Rates and photos will be published when we open. Leave us your email to be notified first.",
    "gite.notifyMe": "Notify me when it opens",
    "gite.secure": "Secure payment by Stripe",
    "gite.towels": "Towels provided",
    "gite.checkin": "Check-in from 4 pm · check-out before 11 am",
    "gite.photoAlt": "Lodging photo",
    "book.eyebrow": "Online booking",
    "book.title": "Choose your dates",
    "book.intro": "Crossed-out nights are already booked. Booking is not instant: we review each request within 48 hours, and payment takes place at that point.",
    "book.sentTitle": "Request sent",
    "book.sentText": "Thank you! We are redirecting you to secure Stripe payment to register your card. No amount is charged: we confirm your request within 48 hours and only then is the payment collected. If we decline, the hold is released immediately.",
    "book.details": "Your details",
    "book.name": "Full name *",
    "book.email": "Email *",
    "book.phone": "Phone",
    "book.guests": "Number of guests *",
    "book.person": "guest",
    "book.persons": "guests",
    "book.adults": "Number of adult guests *",
    "book.adultsNote": "Used to calculate the tourist tax (minors exempt)",
    "book.adultsAuto": "Calculated from the list of guests below. Used to calculate the tourist tax (minors exempt).",
    "book.purpose": "Purpose of your stay (optional)",
    "book.firstName": "First name *",
    "book.lastName": "Last name *",
    "book.nationality": "Nationality *",
    "book.addr1": "Address *",
    "book.zip": "Postcode *",
    "book.city": "Town *",
    "book.country": "Country *",
    "book.holder": "Booking holder",
    "book.occupants": "Other guests",
    "book.occupantsNote": "Last name, first name, status and nationality of each accompanying guest, required for the rental contract.",
    "book.occupant": "Guest {n}",
    "book.adult": "Adult",
    "book.minor": "Minor",
    "police.eyebrow": "Legal formality",
    "police.title": "Individual police registration form",
    "police.intro": "French regulations require an individual form for every guest of foreign nationality staying in a holiday rental. Please complete and sign it on the day of your arrival.",
    "police.stay": "{g} · from {a} to {d}",
    "police.lastName": "Surname",
    "police.firstNames": "First names",
    "police.birthDate": "Date of birth",
    "police.birthPlace": "Place of birth",
    "police.nationality": "Nationality",
    "police.home": "Usual home address",
    "police.mobile": "Mobile phone",
    "police.email": "Email address",
    "police.children": "Accompanying children under 15 (names, optional)",
    "police.signature": "Signature",
    "police.clear": "Clear",
    "police.needSignature": "Please sign before sending the form",
    "police.saved": "Form saved. Thank you!",
    "police.error": "Could not save, please try again",
    "police.unknown": "This form is no longer available",
    "police.done": "Signed",
    "police.fill": "Complete",
    "police.send": "Send the form",
    "police.saving": "Saving…",
    "police.back": "Back",
    "police.none": "No form is required for this stay.",
    "police.privacy": "This information is collected to meet a legal obligation, kept for 6 months and then deleted automatically, and disclosed only to the police or gendarmerie upon their request.",
    "police.prepare": "Save my details",
    "police.prepareHint": "You can prepare your details now: they will be saved and you will only need to sign on the day of your arrival, as the regulations require.",
    "police.draftSaved": "Details saved. Only the signature is left, on arrival.",
    "police.prepared": "Prepared — to be signed on arrival",
    "police.continue": "Resume and sign",
    "faq.title": "Frequently asked questions",
    "faq.q1": "Where is La Ferme Comtoise?",
    "faq.a1": "At 2 rue de la Gypserie, 25500 Les Fins, in the Haut-Doubs — about ten minutes from Morteau and a quarter of an hour from the Swiss border.",
    "faq.q2": "How many people can stay in Le Chalet?",
    "faq.a2": "Up to 6 guests across 90 m²: two bedrooms and three beds (a queen size bed in the first, two double beds in the second).",
    "faq.q3": "Is Le Chalet classified?",
    "faq.a3": "Yes, Le Chalet is a 4-star classified holiday rental. La Ferme currently holds no classification and is not yet open for booking.",
    "faq.q4": "Can I book directly on the website?",
    "faq.a4": "Yes. Your request is not a firm booking: your card is only pre-authorised, with no charge. We reply within 48 hours and the amount is collected only once we have accepted.",
    "faq.q5": "What are the check-in and check-out times?",
    "faq.a5": "Check-in from 4 pm and check-out before 11 am.",
    "faq.q6": "Are bed linen and towels provided?",
    "faq.a6": "Towels are provided and the beds are made up before your arrival. On departure you are simply asked to strip the beds you used and leave the used towels in the bathtub.",
    "faq.q7": "What is the cleaning fee?",
    "faq.a7": "€40 for a stay of 1 to 2 nights and €60 from 3 nights. Normal final cleaning is carried out by us and included in that fee.",
    "faq.q8": "How does the €350 deposit work?",
    "faq.a8": "It is a card hold, with no charge. It can only be captured, in whole or in part, up to 7 days after departure and solely with written evidence. Where there is no incident, no amount is charged.",
    "faq.q9": "Are pets allowed?",
    "faq.a9": "No, pets are not allowed. The accommodation is non-smoking, parties are prohibited and quiet is requested after 10 pm.",
    "faq.q10": "Is there parking and self check-in?",
    "faq.a10": "Yes: two free parking spaces at the foot of the house and self check-in via a secure key box, the code for which is emailed to you before arrival.",
    "faq.q11": "What is the cancellation policy?",
    "faq.a11": "100% refund more than 14 days before arrival, 50% of the price of the stay from 14 to 7 days (inclusive), no refund less than 7 days before. Any cancellation must be sent in writing to contact@lafermecomtoise.com.",
    "book.message": "Message (tell us about your stay)",
    "book.submit": "Send my booking request",
    "book.sending": "Sending request…",
    "book.legal": "No charge before our approval: your card is only pre-authorised. We confirm within 48 h; the amount is collected only then and the hold is released if we decline.",
    "rev.source": "Review originally published on {s}",
    "book.stay": "Your stay",
    "book.arrival": "Check-in",
    "book.departure": "Check-out",
    "book.nights": "nights",
    "book.cleaning": "Cleaning fee",
    "book.tax": "Tourist tax",
    "book.taxLine": "€{r} × {g} guests × {n} nights",
    "book.total": "Total",
    "book.taxNote": "Tourist tax of €{r} per night and per adult guest, collected on behalf of {c}. Mandatory cleaning fee: €40 up to 2 nights, €60 from 3 nights. A {d} deposit is pre-authorised on your card without being charged, and may be collected up to 7 days after departure with written justification (see the ",
    "book.taxNoteCgv": "terms & conditions",
    "book.pickDates": "Select a check-in date then a check-out date in the calendar.",
    "book.errNoDates": "Please choose your dates first",
    "book.toastSent": "Request sent! Reply within 48 hours.",
    "purpose.holiday": "Holiday",
    "purpose.family": "Family weekend",
    "purpose.friends": "Trip with friends",
    "purpose.work": "Business trip",
    "purpose.ski": "Skiing / winter sports",
    "purpose.event": "Family celebration",
    "purpose.other": "Other",
    "rev.eyebrow": "Guest experiences",
    "rev.title": "What our guests say",
    "rev.emptyTitle": "The first reviews are on their way",
    "rev.emptyText": "La Ferme Comtoise has just opened its doors. Our first guests are staying right now: their feedback will be published here, unfiltered.",
    "rev.ctaTitle": "Have you stayed with us?",
    "rev.ctaText": "Write to us and we will publish your feedback as it is.",
    "rev.cta": "Leave a review",
    "revf.eyebrow": "Your stay",
    "revf.title": "Leave your review",
    "revf.intro": "A few lines are enough. Your review will be published once approved by the owners.",
    "revf.author": "Your name *",
    "revf.city": "Town",
    "revf.rating": "Rating",
    "revf.star": "star",
    "revf.stars": "stars",
    "revf.text": "Your review *",
    "revf.submit": "Send my review",
    "revf.thanks": "Thank you!",
    "revf.thanksText": "Your review has been sent. It will be published on the site after we have read it.",
    "revf.home": "Back to home",
    "ct.eyebrow": "Write to us",
    "ct.title1": "A question?",
    "ct.title2": "A group stay?",
    "ct.intro": "We answer every message personally, usually the same day.",
    "ct.name": "Name *",
    "ct.email": "Email *",
    "ct.phone": "Phone",
    "ct.subject": "Subject",
    "ct.message": "Message *",
    "ct.send": "Send message",
    "ct.sending": "Sending…",
    "ct.success": "Thank you! Your message has been received.",
    "ct.toast": "Message sent! We reply within 24 h.",
    "ct.address": "Address",
    "ct.emailLabel": "Email",
    "ct.checkinout": "Check-in / check-out",
    "ct.checkinoutValue": "Check-in from 4 pm · check-out before 11 am",
    "ct.map": "Map of Les Fins",
    "subj.info": "Information request",
    "subj.group": "Group booking (10 guests)",
    "subj.avail": "Availability",
    "subj.review": "Leave a review",
    "subj.other": "Other",
    "legal.eyebrow": "Legal information",
  },
  de: {
    "months": ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    "dow": ["M", "D", "M", "D", "F", "S", "S"],
    "cal.loading": "lädt",
    "cal.selection": "Auswahl",
    "cal.included": "Enthaltene Nächte",
    "cal.unavailable": "Nicht verfügbar",
    "nav.gites": "Unsere Ferienwohnungen",
    "nav.reviews": "Bewertungen",
    "nav.contact": "Kontakt",
    "nav.book": "Buchen",
    "nav.soon": "Demnächst",
    "footer.tagline": "Zwei Ferienwohnungen in einem typischen Bauernhaus im Haut-Doubs, nur wenige Minuten von der Schweizer Grenze. Le Chalet ist mit 4 Sternen klassifiziert.",
    "footer.find": "So finden Sie uns",
    "footer.domain": "Das Anwesen",
    "footer.chalet": "Le Chalet · 6 Personen",
    "footer.ferme": "La Ferme · 4 Personen",
    "footer.both": "Beide Wohnungen · 10 Personen",
    "footer.cgv": "AGB",
    "footer.cancel": "Stornobedingungen",
    "footer.legal": "Impressum",
    "footer.privacy": "Datenschutz",
    "footer.owner": "Eigentümerbereich",
    "footer.bottom": "La Ferme Comtoise — Le Chalet, 4★ klassifiziert — Sichere Zahlung mit Stripe",
    "home.house": "Das Haus",
    "home.title": "Ein typisches Bauernhaus des Haut-Doubs aus den 1800er Jahren",
    "home.p1": "Willkommen im Herzen des Haut-Doubs, in einem authentischen Bauernhaus nur fünfzehn Minuten von der Schweiz entfernt. Entfliehen Sie dem Alltag in unseren Ferienwohnungen – ideale Orte, um zusammen zu sein, neue Kraft zu schöpfen und die Schönheit der Region zu genießen.",
    "home.p2a": "Unsere ",
    "home.p2b": "zwei Wohnungen",
    "home.p2c": " können auch gemeinsam gemietet werden und bieten Platz für bis zu zehn Personen – perfekt für besondere Momente mit Familie oder Freunden.",
    "home.activities": "Beispiele für Aktivitäten während Ihres französisch-schweizerischen Aufenthalts",
    "act.bike": "Mountainbike",
    "act.ski": "Ski",
    "act.snowshoe": "Schneeschuhwandern",
    "act.hike": "Wandern",
    "act.museum": "Uhrenmuseen",
    "act.absinthe": "Die Absinth-Route",
    "home.lodgings": "Unsere Wohnungen",
    "home.rentBoth": "Beide Wohnungen gleichzeitig mieten",
    "home.details": "Fotos, Infos & Kalender",
    "home.detailsSoon": "Demnächst verfügbar · mehr erfahren",
    "unit.pers": "Pers.",
    "unit.rooms": "Zi.",
    "unit.baths": "Bad",
    "gite.loading": "Lädt…",
    "gite.notfound": "Wohnung nicht gefunden.",
    "gite.back": "Zurück",
    "gite.soonBadge": "Demnächst",
    "gite.upcoming": "Demnächst",
    "gite.giteFor": "Ferienwohnung für {n} Personen",
    "gite.bookThis": "Diese Wohnung buchen",
    "gite.lodging": "Die Wohnung",
    "gite.travelers": "{n} Gäste",
    "gite.bedsLine": "{r} Schlafzimmer · {b} Betten",
    "gite.bathroom": "{n} Badezimmer",
    "gite.amenities": "Ausstattung",
    "gite.good2know": "Gut zu wissen",
    "gite.gallery": "Galerie",
    "gite.galleryWait": "Die Einrichtung läuft: Die Fotos werden zur Eröffnung veröffentlicht.",
    "gite.availability": "Verfügbarkeit & Preise",
    "gite.calendar": "Kalender",
    "gite.from": "Ab",
    "gite.perNight": " / Nacht",
    "gite.priceNote": "Preise je nach Datum – der Kalender zeigt den Preis Ihres Aufenthalts. Pflicht-Endreinigung: 40 € bis 2 Nächte, 60 € ab 3 Nächten.",
    "gite.rates": "Preise je nach Datum",
    "book.cgvAccept": "Ich habe die AGB und die Stornierungsbedingungen gelesen und akzeptiere sie.",
    "book.cgvLink": "AGB",
    "book.cancelLink": "Stornierungsbedingungen",
    "book.cgvRequired": "Bitte akzeptieren Sie zuerst die AGB",
    "book.deposit": "Kaution (Kartenreservierung, ohne Abbuchung)",
    "book.recapTitle": "Bei Bestätigung zu zahlen",
    "book.payObligation": "Weiter zur sicheren Zahlung (zahlungspflichtig)",
    "gite.opening": "Eröffnung",
    "gite.soonAvailable": "Demnächst verfügbar",
    "gite.openNote": "Preise und Fotos werden zur Eröffnung veröffentlicht. Hinterlassen Sie uns Ihre E-Mail, um vorrangig informiert zu werden.",
    "gite.notifyMe": "Über die Eröffnung informieren",
    "gite.secure": "Sichere Zahlung über Stripe",
    "gite.towels": "Handtücher inklusive",
    "gite.checkin": "Anreise ab 16 Uhr · Abreise bis 11 Uhr",
    "gite.photoAlt": "Foto der Wohnung",
    "book.eyebrow": "Online-Buchung",
    "book.title": "Wählen Sie Ihre Daten",
    "book.intro": "Durchgestrichene Nächte sind bereits belegt. Die Buchung erfolgt nicht sofort: Wir prüfen jede Anfrage innerhalb von 48 Stunden, die Zahlung erfolgt danach.",
    "book.sentTitle": "Anfrage gesendet",
    "book.sentText": "Vielen Dank! Wir leiten Sie zur sicheren Stripe-Zahlung weiter, um Ihre Karte zu registrieren. Es wird kein Betrag abgebucht: Wir bestätigen Ihre Anfrage innerhalb von 48 Stunden und erst dann wird der Betrag eingezogen. Bei einer Ablehnung wird die Reservierung sofort freigegeben.",
    "book.details": "Ihre Kontaktdaten",
    "book.name": "Vollständiger Name *",
    "book.email": "E-Mail *",
    "book.phone": "Telefon",
    "book.guests": "Anzahl der Personen *",
    "book.person": "Person",
    "book.persons": "Personen",
    "book.adults": "Anzahl volljähriger Personen *",
    "book.adultsNote": "Berechnungsgrundlage der Kurtaxe (Minderjährige befreit)",
    "book.adultsAuto": "Berechnet anhand der untenstehenden Gästeliste. Grundlage für die Kurtaxe (Minderjährige befreit).",
    "book.purpose": "Anlass des Aufenthalts (optional)",
    "book.firstName": "Vorname *",
    "book.lastName": "Name *",
    "book.nationality": "Staatsangehörigkeit *",
    "book.addr1": "Adresse *",
    "book.zip": "Postleitzahl *",
    "book.city": "Ort *",
    "book.country": "Land *",
    "book.holder": "Buchungsinhaber",
    "book.occupants": "Weitere Gäste",
    "book.occupantsNote": "Name, Vorname, Status und Staatsangehörigkeit jedes begleitenden Gastes, für den Mietvertrag erforderlich.",
    "book.occupant": "Gast {n}",
    "book.adult": "Erwachsen",
    "book.minor": "Minderjährig",
    "police.eyebrow": "Gesetzliche Formalität",
    "police.title": "Individuelle Polizeimeldekarte",
    "police.intro": "Die französische Regelung verlangt für jeden Gast ausländischer Staatsangehörigkeit in einer Ferienunterkunft eine individuelle Meldekarte. Bitte füllen Sie sie am Tag Ihrer Ankunft aus und unterschreiben Sie sie.",
    "police.stay": "{g} · vom {a} bis {d}",
    "police.lastName": "Name",
    "police.firstNames": "Vornamen",
    "police.birthDate": "Geburtsdatum",
    "police.birthPlace": "Geburtsort",
    "police.nationality": "Staatsangehörigkeit",
    "police.home": "Gewöhnlicher Wohnsitz",
    "police.mobile": "Mobiltelefon",
    "police.email": "E-Mail-Adresse",
    "police.children": "Begleitende Kinder unter 15 Jahren (Namen, optional)",
    "police.signature": "Unterschrift",
    "police.clear": "Löschen",
    "police.needSignature": "Bitte unterschreiben Sie vor dem Absenden",
    "police.saved": "Meldekarte gespeichert. Vielen Dank!",
    "police.error": "Speichern nicht möglich, bitte erneut versuchen",
    "police.unknown": "Diese Meldekarte ist nicht mehr verfügbar",
    "police.done": "Unterschrieben",
    "police.fill": "Ausfüllen",
    "police.send": "Meldekarte senden",
    "police.saving": "Speichern…",
    "police.back": "Zurück",
    "police.none": "Für diesen Aufenthalt ist keine Meldekarte erforderlich.",
    "police.privacy": "Diese Angaben werden zur Erfüllung einer gesetzlichen Pflicht erhoben, 6 Monate aufbewahrt und danach automatisch gelöscht; sie werden ausschließlich auf Anforderung an Polizei oder Gendarmerie übermittelt.",
    "police.prepare": "Meine Angaben speichern",
    "police.prepareHint": "Sie können Ihre Angaben schon jetzt vorbereiten: Sie werden gespeichert, und am Anreisetag müssen Sie nur noch unterschreiben, wie es die Vorschriften verlangen.",
    "police.draftSaved": "Angaben gespeichert. Es fehlt nur noch die Unterschrift bei der Ankunft.",
    "police.prepared": "Vorbereitet — bei Ankunft zu unterschreiben",
    "police.continue": "Fortsetzen und unterschreiben",
    "faq.title": "Häufige Fragen",
    "faq.q1": "Wo liegt La Ferme Comtoise?",
    "faq.a1": "In 2 rue de la Gypserie, 25500 Les Fins im Haut-Doubs — rund zehn Minuten von Morteau und eine Viertelstunde von der Schweizer Grenze entfernt.",
    "faq.q2": "Für wie viele Personen ist Le Chalet geeignet?",
    "faq.a2": "Bis zu 6 Gäste auf 90 m²: zwei Schlafzimmer und drei Betten (ein Queen-Size-Bett im ersten, zwei Doppelbetten im zweiten).",
    "faq.q3": "Ist Le Chalet klassifiziert?",
    "faq.a3": "Ja, Le Chalet ist eine mit 4 Sternen klassifizierte Ferienwohnung. La Ferme hat derzeit keine Klassifizierung und ist noch nicht buchbar.",
    "faq.q4": "Kann man direkt auf der Website buchen?",
    "faq.a4": "Ja. Ihre Anfrage ist keine feste Buchung: Ihre Karte wird nur vorautorisiert, ohne Abbuchung. Wir antworten innerhalb von 48 Stunden; der Betrag wird erst nach unserer Zusage eingezogen.",
    "faq.q5": "Wie sind die An- und Abreisezeiten?",
    "faq.a5": "Anreise ab 16 Uhr und Abreise bis 11 Uhr.",
    "faq.q6": "Werden Bettwäsche und Handtücher gestellt?",
    "faq.a6": "Handtücher werden gestellt und die Betten sind bei Ihrer Ankunft bezogen. Bei der Abreise bitten wir Sie lediglich, die benutzten Betten abzuziehen und die benutzten Handtücher in die Badewanne zu legen.",
    "faq.q7": "Wie hoch ist die Endreinigung?",
    "faq.a7": "40 € bei 1 bis 2 Nächten und 60 € ab 3 Nächten. Die normale Endreinigung übernehmen wir und sie ist in dieser Pauschale enthalten.",
    "faq.q8": "Wie funktioniert die Kaution von 350 €?",
    "faq.a8": "Es handelt sich um eine Kartenreservierung ohne Abbuchung. Sie kann ganz oder teilweise nur bis 7 Tage nach der Abreise und ausschließlich mit schriftlichem Nachweis eingezogen werden. Ohne Vorfall erfolgt keine Abbuchung.",
    "faq.q9": "Sind Haustiere erlaubt?",
    "faq.a9": "Nein, Haustiere sind nicht erlaubt. Die Unterkunft ist Nichtraucher, Partys sind untersagt und nach 22 Uhr wird um Ruhe gebeten.",
    "faq.q10": "Gibt es Parkplätze und einen selbstständigen Zugang?",
    "faq.a10": "Ja: zwei kostenlose Parkplätze direkt am Haus und ein selbstständiger Zugang über einen sicheren Schlüsselkasten, dessen Code Ihnen vor der Anreise per E-Mail zugesandt wird.",
    "faq.q11": "Wie lauten die Stornierungsbedingungen?",
    "faq.a11": "100 % Erstattung bei mehr als 14 Tagen vor der Anreise, 50 % des Aufenthaltspreises von 14 bis 7 Tagen (jeweils einschließlich), keine Erstattung bei weniger als 7 Tagen. Jede Stornierung muss schriftlich an contact@lafermecomtoise.com gerichtet werden.",
    "book.message": "Nachricht (erzählen Sie uns von Ihrem Aufenthalt)",
    "book.submit": "Buchungsanfrage senden",
    "book.sending": "Anfrage wird gesendet…",
    "book.legal": "Keine Abbuchung vor unserer Zusage: Ihre Karte wird nur vorautorisiert. Wir bestätigen innerhalb von 48 Stunden; erst dann wird der Betrag eingezogen, bei Ablehnung wird die Reservierung freigegeben.",
    "rev.source": "Bewertung ursprünglich veröffentlicht auf {s}",
    "book.stay": "Ihr Aufenthalt",
    "book.arrival": "Anreise",
    "book.departure": "Abreise",
    "book.nights": "Nächte",
    "book.cleaning": "Reinigungsgebühr",
    "book.tax": "Kurtaxe",
    "book.taxLine": "{r} € × {g} Pers. × {n} Nächte",
    "book.total": "Gesamt",
    "book.taxNote": "Kurtaxe von {r} € pro Nacht und volljähriger Person, erhoben für {c}. Pflicht-Endreinigung: 40 € bis 2 Nächte, 60 € ab 3 Nächten. Kaution von {d} als Kartenreservierung ohne Abbuchung, bis 7 Tage nach der Abreise mit Nachweis einziehbar (siehe ",
    "book.taxNoteCgv": "AGB",
    "book.pickDates": "Wählen Sie im Kalender ein Anreise- und dann ein Abreisedatum.",
    "book.errNoDates": "Bitte wählen Sie zuerst Ihre Daten",
    "book.toastSent": "Anfrage gesendet! Antwort innerhalb von 48 Stunden.",
    "purpose.holiday": "Urlaub",
    "purpose.family": "Familienwochenende",
    "purpose.friends": "Aufenthalt mit Freunden",
    "purpose.work": "Geschäftsreise",
    "purpose.ski": "Ski / Wintersport",
    "purpose.event": "Familienfeier",
    "purpose.other": "Sonstiges",
    "rev.eyebrow": "Erfahrungen",
    "rev.title": "Was unsere Gäste sagen",
    "rev.emptyTitle": "Die ersten Bewertungen kommen bald",
    "rev.emptyText": "La Ferme Comtoise hat gerade eröffnet. Unsere ersten Gäste sind aktuell da: Ihre Rückmeldungen werden hier ungefiltert veröffentlicht.",
    "rev.ctaTitle": "Haben Sie bei uns übernachtet?",
    "rev.ctaText": "Schreiben Sie uns, wir veröffentlichen Ihre Rückmeldung unverändert.",
    "rev.cta": "Bewertung abgeben",
    "revf.eyebrow": "Ihr Aufenthalt",
    "revf.title": "Hinterlassen Sie Ihre Bewertung",
    "revf.intro": "Ein paar Zeilen genügen. Ihre Bewertung wird nach Prüfung durch die Eigentümer veröffentlicht.",
    "revf.author": "Ihr Name *",
    "revf.city": "Stadt",
    "revf.rating": "Note",
    "revf.star": "Stern",
    "revf.stars": "Sterne",
    "revf.text": "Ihre Bewertung *",
    "revf.submit": "Bewertung senden",
    "revf.thanks": "Vielen Dank!",
    "revf.thanksText": "Ihre Bewertung wurde übermittelt. Sie wird nach unserer Durchsicht auf der Website veröffentlicht.",
    "revf.home": "Zurück zur Startseite",
    "ct.eyebrow": "Schreiben Sie uns",
    "ct.title1": "Eine Frage?",
    "ct.title2": "Ein Gruppenaufenthalt?",
    "ct.intro": "Wir antworten persönlich auf jede Nachricht, meist noch am selben Tag.",
    "ct.name": "Name *",
    "ct.email": "E-Mail *",
    "ct.phone": "Telefon",
    "ct.subject": "Betreff",
    "ct.message": "Nachricht *",
    "ct.send": "Nachricht senden",
    "ct.sending": "Senden…",
    "ct.success": "Danke! Ihre Nachricht ist angekommen.",
    "ct.toast": "Nachricht gesendet! Wir antworten innerhalb von 24 Stunden.",
    "ct.address": "Adresse",
    "ct.emailLabel": "E-Mail",
    "ct.checkinout": "Anreise / Abreise",
    "ct.checkinoutValue": "Anreise ab 16 Uhr · Abreise bis 11 Uhr",
    "ct.map": "Karte Les Fins",
    "subj.info": "Informationsanfrage",
    "subj.group": "Gruppenbuchung (10 Personen)",
    "subj.avail": "Verfügbarkeit",
    "subj.review": "Bewertung abgeben",
    "subj.other": "Sonstiges",
    "legal.eyebrow": "Rechtliche Hinweise",
  },
  es: {
    "months": ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
    "dow": ["L", "M", "M", "J", "V", "S", "D"],
    "cal.loading": "cargando",
    "cal.selection": "Selección",
    "cal.included": "Noches incluidas",
    "cal.unavailable": "No disponible",
    "nav.gites": "Nuestros alojamientos",
    "nav.reviews": "Opiniones",
    "nav.contact": "Contacto",
    "nav.book": "Reservar",
    "nav.soon": "Próximamente",
    "footer.tagline": "Dos alojamientos en una auténtica granja comtesa del Haut-Doubs, a pocos minutos de la frontera suiza. Le Chalet está clasificado con 4 estrellas.",
    "footer.find": "Cómo encontrarnos",
    "footer.domain": "La propiedad",
    "footer.chalet": "Le Chalet · 6 personas",
    "footer.ferme": "La Ferme · 4 personas",
    "footer.both": "Los dos alojamientos · 10 personas",
    "footer.cgv": "Condiciones generales",
    "footer.cancel": "Política de cancelación",
    "footer.legal": "Aviso legal",
    "footer.privacy": "Privacidad",
    "footer.owner": "Área del propietario",
    "footer.bottom": "La Ferme Comtoise — Le Chalet, alojamiento turístico 4★ — Pago seguro con Stripe",
    "home.house": "La casa",
    "home.title": "Una granja típica del Haut-Doubs de los años 1800",
    "home.p1": "Bienvenido al corazón del Haut-Doubs, en una auténtica granja comtesa a solo quince minutos de Suiza. Escápese a nuestros alojamientos, lugares ideales para reencontrarse, recargar energías y disfrutar plenamente de la belleza de la región.",
    "home.p2a": "Nuestros ",
    "home.p2b": "dos apartamentos",
    "home.p2c": " también pueden alquilarse juntos para acoger hasta diez personas, en un marco ideal para compartir momentos especiales en familia o con amigos.",
    "home.activities": "Ejemplos de actividades para su estancia franco-suiza",
    "act.bike": "BTT",
    "act.ski": "Esquí",
    "act.snowshoe": "Raquetas de nieve",
    "act.hike": "Senderismo",
    "act.museum": "Museos de la relojería",
    "act.absinthe": "La ruta de la absenta",
    "home.lodgings": "Nuestros alojamientos",
    "home.rentBoth": "Alquilar los dos alojamientos a la vez",
    "home.details": "Fotos, información y calendario",
    "home.detailsSoon": "Disponible próximamente · saber más",
    "unit.pers": "pers.",
    "unit.rooms": "hab.",
    "unit.baths": "baño",
    "gite.loading": "Cargando…",
    "gite.notfound": "Alojamiento no encontrado.",
    "gite.back": "Volver",
    "gite.soonBadge": "Próximamente",
    "gite.upcoming": "Próximamente",
    "gite.giteFor": "Alojamiento para {n} personas",
    "gite.bookThis": "Reservar este alojamiento",
    "gite.lodging": "El alojamiento",
    "gite.travelers": "{n} viajeros",
    "gite.bedsLine": "{r} habitaciones · {b} camas",
    "gite.bathroom": "{n} baño",
    "gite.amenities": "Equipamiento",
    "gite.good2know": "Información útil",
    "gite.gallery": "Galería",
    "gite.galleryWait": "Las obras de acondicionamiento están en curso: las fotos se publicarán en la apertura.",
    "gite.availability": "Disponibilidad y tarifas",
    "gite.calendar": "Calendario",
    "gite.from": "Desde",
    "gite.perNight": " / noche",
    "gite.priceNote": "Tarifas según las fechas – consulte el calendario para conocer el precio de su estancia. Limpieza obligatoria: 40 € hasta 2 noches, 60 € a partir de 3 noches.",
    "gite.rates": "Tarifas según las fechas",
    "book.cgvAccept": "He leído y acepto las condiciones generales de venta y la política de cancelación.",
    "book.cgvLink": "Condiciones de venta",
    "book.cancelLink": "política de cancelación",
    "book.cgvRequired": "Acepte las condiciones antes de continuar",
    "book.deposit": "Fianza (preautorización, sin cargo)",
    "book.recapTitle": "A pagar en la confirmación",
    "book.payObligation": "Continuar al pago seguro (obligación de pago)",
    "gite.opening": "Apertura",
    "gite.soonAvailable": "Disponible próximamente",
    "gite.openNote": "Las tarifas y las fotos se publicarán en la apertura. Déjenos su correo para avisarle con prioridad.",
    "gite.notifyMe": "Avisarme de la apertura",
    "gite.secure": "Pago seguro con Stripe",
    "gite.towels": "Toallas incluidas",
    "gite.checkin": "Llegada desde las 16 h · salida antes de las 11 h",
    "gite.photoAlt": "Foto del alojamiento",
    "book.eyebrow": "Reserva en línea",
    "book.title": "Elija sus fechas",
    "book.intro": "Las noches tachadas ya están reservadas. La reserva no es inmediata: validamos cada solicitud en 48 horas y el pago se realiza en ese momento.",
    "book.sentTitle": "Solicitud enviada",
    "book.sentText": "¡Gracias! Le redirigimos al pago seguro de Stripe para registrar su tarjeta. No se realiza ningún cargo: validamos su solicitud en 48 horas y solo entonces se cobra el importe. Si la rechazamos, la preautorización se libera de inmediato.",
    "book.details": "Sus datos",
    "book.name": "Nombre completo *",
    "book.email": "Correo electrónico *",
    "book.phone": "Teléfono",
    "book.guests": "Número de personas *",
    "book.person": "persona",
    "book.persons": "personas",
    "book.adults": "Número de personas adultas *",
    "book.adultsNote": "Base de cálculo de la tasa turística (menores exentos)",
    "book.adultsAuto": "Calculado a partir de la lista de viajeros de abajo. Base de cálculo de la tasa turística (menores exentos).",
    "book.purpose": "Motivo de la estancia (opcional)",
    "book.firstName": "Nombre *",
    "book.lastName": "Apellidos *",
    "book.nationality": "Nacionalidad *",
    "book.addr1": "Dirección *",
    "book.zip": "Código postal *",
    "book.city": "Ciudad *",
    "book.country": "País *",
    "book.holder": "Titular de la reserva",
    "book.occupants": "Otros viajeros",
    "book.occupantsNote": "Apellidos, nombre, estatus y nacionalidad de cada acompañante, necesarios para el contrato de alquiler.",
    "book.occupant": "Viajero {n}",
    "book.adult": "Adulto",
    "book.minor": "Menor",
    "police.eyebrow": "Formalidad legal",
    "police.title": "Ficha individual de policía",
    "police.intro": "La normativa francesa exige una ficha individual para cada viajero de nacionalidad extranjera alojado en un alojamiento turístico. Complétela y fírmela el día de su llegada.",
    "police.stay": "{g} · del {a} al {d}",
    "police.lastName": "Apellidos",
    "police.firstNames": "Nombre(s)",
    "police.birthDate": "Fecha de nacimiento",
    "police.birthPlace": "Lugar de nacimiento",
    "police.nationality": "Nacionalidad",
    "police.home": "Domicilio habitual",
    "police.mobile": "Teléfono móvil",
    "police.email": "Correo electrónico",
    "police.children": "Niños menores de 15 años acompañantes (nombres, opcional)",
    "police.signature": "Firma",
    "police.clear": "Borrar",
    "police.needSignature": "Firme antes de enviar la ficha",
    "police.saved": "Ficha registrada. ¡Gracias!",
    "police.error": "No se ha podido guardar, inténtelo de nuevo",
    "police.unknown": "Esta ficha ya no está disponible",
    "police.done": "Firmada",
    "police.fill": "Rellenar",
    "police.send": "Enviar la ficha",
    "police.saving": "Guardando…",
    "police.back": "Volver",
    "police.none": "No se requiere ninguna ficha para esta estancia.",
    "police.privacy": "Estos datos se recogen para cumplir una obligación legal, se conservan 6 meses y después se suprimen automáticamente, y solo se comunican a la policía o la gendarmería a petición suya.",
    "police.prepare": "Guardar mis datos",
    "police.prepareHint": "Puede preparar sus datos ahora mismo: se conservarán y solo tendrá que firmar el día de su llegada, como exige la normativa.",
    "police.draftSaved": "Datos guardados. Solo falta la firma, a la llegada.",
    "police.prepared": "Preparada — pendiente de firma a la llegada",
    "police.continue": "Retomar y firmar",
    "faq.title": "Preguntas frecuentes",
    "faq.q1": "¿Dónde se encuentra La Ferme Comtoise?",
    "faq.a1": "En 2 rue de la Gypserie, 25500 Les Fins, en el Haut-Doubs: a unos diez minutos de Morteau y a un cuarto de hora de la frontera suiza.",
    "faq.q2": "¿Cuántas personas pueden alojarse en Le Chalet?",
    "faq.a2": "Hasta 6 viajeros en 90 m²: dos dormitorios y tres camas (una cama queen size en el primero, dos camas dobles en el segundo).",
    "faq.q3": "¿Está clasificado Le Chalet?",
    "faq.a3": "Sí, Le Chalet es un alojamiento turístico clasificado con 4 estrellas. La Ferme no tiene clasificación a día de hoy y todavía no está abierta a reserva.",
    "faq.q4": "¿Se puede reservar directamente en la web?",
    "faq.a4": "Sí. Su solicitud no es una reserva firme: su tarjeta solo queda preautorizada, sin cargo. Respondemos en 48 horas y el importe solo se cobra tras nuestra aceptación.",
    "faq.q5": "¿Cuáles son los horarios de llegada y salida?",
    "faq.a5": "Llegada a partir de las 16 h y salida antes de las 11 h.",
    "faq.q6": "¿Se facilitan sábanas y toallas?",
    "faq.a6": "Las toallas están incluidas y las camas están preparadas antes de su llegada. A la salida solo le pedimos deshacer las camas utilizadas y dejar las toallas usadas en la bañera.",
    "faq.q7": "¿Cuáles son los gastos de limpieza?",
    "faq.a7": "40 € para una estancia de 1 a 2 noches y 60 € a partir de 3 noches. La limpieza final normal corre de nuestra cuenta y está incluida en ese importe.",
    "faq.q8": "¿Cómo funciona la fianza de 350 €?",
    "faq.a8": "Se trata de una preautorización bancaria, sin cargo. Solo puede cobrarse, total o parcialmente, hasta 7 días después de la salida y únicamente con justificación escrita. Sin incidencias, no se efectúa ningún cargo.",
    "faq.q9": "¿Se admiten animales?",
    "faq.a9": "No, no se admiten animales. El alojamiento es para no fumadores, las fiestas están prohibidas y se pide silencio a partir de las 22 h.",
    "faq.q10": "¿Hay aparcamiento y entrada autónoma?",
    "faq.a10": "Sí: dos plazas de aparcamiento gratuitas al pie de la casa y acceso autónomo mediante caja de llaves segura, cuyo código se le envía por correo antes de la llegada.",
    "faq.q11": "¿Cuáles son las condiciones de cancelación?",
    "faq.a11": "Reembolso del 100 % a más de 14 días de la llegada, del 50 % del precio de la estancia de 14 a 7 días (ambos incluidos) y ningún reembolso a menos de 7 días. Toda cancelación debe dirigirse por escrito a contact@lafermecomtoise.com.",
    "book.message": "Mensaje (cuéntenos su estancia)",
    "book.submit": "Enviar mi solicitud de reserva",
    "book.sending": "Enviando la solicitud…",
    "book.legal": "Ningún cargo antes de nuestra aceptación: su tarjeta solo queda preautorizada. Validamos en 48 h; el importe solo se cobra en ese momento y la preautorización se libera si rechazamos.",
    "rev.source": "Opinión publicada inicialmente en {s}",
    "book.stay": "Su estancia",
    "book.arrival": "Llegada",
    "book.departure": "Salida",
    "book.nights": "noches",
    "book.cleaning": "Gastos de limpieza",
    "book.tax": "Tasa turística",
    "book.taxLine": "{r} € × {g} pers. × {n} noches",
    "book.total": "Total",
    "book.taxNote": "Tasa turística de {r} € por noche y por persona adulta, recaudada para {c}. Limpieza obligatoria: 40 € hasta 2 noches, 60 € a partir de 3 noches. Fianza de {d} mediante preautorización en la tarjeta, sin cargo, cobrable hasta 7 días después de la salida con justificación (ver las ",
    "book.taxNoteCgv": "condiciones generales",
    "book.pickDates": "Seleccione una fecha de llegada y luego de salida en el calendario.",
    "book.errNoDates": "Elija primero sus fechas",
    "book.toastSent": "¡Solicitud enviada! Respuesta en 48 horas.",
    "purpose.holiday": "Vacaciones",
    "purpose.family": "Fin de semana en familia",
    "purpose.friends": "Estancia con amigos",
    "purpose.work": "Viaje de trabajo",
    "purpose.ski": "Esquí / deportes de invierno",
    "purpose.event": "Celebración familiar",
    "purpose.other": "Otro",
    "rev.eyebrow": "Experiencias",
    "rev.title": "Lo que dicen nuestros viajeros",
    "rev.emptyTitle": "Las primeras opiniones están en camino",
    "rev.emptyText": "La Ferme Comtoise acaba de abrir sus puertas. Nuestros primeros huéspedes están alojados ahora mismo: sus comentarios se publicarán aquí, sin filtros.",
    "rev.ctaTitle": "¿Se ha alojado con nosotros?",
    "rev.ctaText": "Escríbanos y publicaremos su comentario tal cual.",
    "rev.cta": "Dejar una opinión",
    "revf.eyebrow": "Su estancia",
    "revf.title": "Deje su opinión",
    "revf.intro": "Unas pocas líneas bastan. Su opinión se publicará tras la validación de los propietarios.",
    "revf.author": "Su nombre *",
    "revf.city": "Ciudad",
    "revf.rating": "Nota",
    "revf.star": "estrella",
    "revf.stars": "estrellas",
    "revf.text": "Su opinión *",
    "revf.submit": "Enviar mi opinión",
    "revf.thanks": "¡Gracias!",
    "revf.thanksText": "Su opinión se ha enviado correctamente. Se publicará en el sitio tras nuestra revisión.",
    "revf.home": "Volver al inicio",
    "ct.eyebrow": "Escríbanos",
    "ct.title1": "¿Una pregunta?",
    "ct.title2": "¿Un proyecto de grupo?",
    "ct.intro": "Respondemos personalmente a cada mensaje, normalmente el mismo día.",
    "ct.name": "Nombre *",
    "ct.email": "Correo electrónico *",
    "ct.phone": "Teléfono",
    "ct.subject": "Asunto",
    "ct.message": "Mensaje *",
    "ct.send": "Enviar el mensaje",
    "ct.sending": "Enviando…",
    "ct.success": "¡Gracias! Su mensaje ha llegado correctamente.",
    "ct.toast": "¡Mensaje enviado! Respondemos en 24 h.",
    "ct.address": "Dirección",
    "ct.emailLabel": "Correo electrónico",
    "ct.checkinout": "Llegada / salida",
    "ct.checkinoutValue": "Llegada desde las 16 h · salida antes de las 11 h",
    "ct.map": "Mapa de Les Fins",
    "subj.info": "Solicitud de información",
    "subj.group": "Reserva de grupo (10 personas)",
    "subj.avail": "Disponibilidad",
    "subj.review": "Dejar una opinión",
    "subj.other": "Otro",
    "legal.eyebrow": "Información legal",
  },
  it: {
    "months": ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"],
    "dow": ["L", "M", "M", "G", "V", "S", "D"],
    "cal.loading": "caricamento",
    "cal.selection": "Selezione",
    "cal.included": "Notti incluse",
    "cal.unavailable": "Non disponibile",
    "nav.gites": "I nostri alloggi",
    "nav.reviews": "Recensioni",
    "nav.contact": "Contatti",
    "nav.book": "Prenota",
    "nav.soon": "Prossimamente",
    "footer.tagline": "Due alloggi in un'autentica cascina del Haut-Doubs, a pochi minuti dal confine svizzero. Le Chalet è classificato 4 stelle.",
    "footer.find": "Come trovarci",
    "footer.domain": "La proprietà",
    "footer.chalet": "Le Chalet · 6 persone",
    "footer.ferme": "La Ferme · 4 persone",
    "footer.both": "I due alloggi · 10 persone",
    "footer.cgv": "Condizioni generali",
    "footer.cancel": "Politica di cancellazione",
    "footer.legal": "Note legali",
    "footer.privacy": "Privacy",
    "footer.owner": "Area proprietario",
    "footer.bottom": "La Ferme Comtoise — Le Chalet, alloggio turistico 4★ — Pagamento sicuro con Stripe",
    "home.house": "La casa",
    "home.title": "Una tipica cascina del Haut-Doubs del 1800",
    "home.p1": "Benvenuti nel cuore del Haut-Doubs, in un'autentica cascina comtoise a soli quindici minuti dalla Svizzera. Rifugiatevi nei nostri alloggi, luoghi ideali per ritrovarsi, rigenerarsi e godere appieno della bellezza della regione.",
    "home.p2a": "I nostri ",
    "home.p2b": "due appartamenti",
    "home.p2c": " possono anche essere affittati insieme per ospitare fino a dieci persone, in una cornice ideale per condividere momenti speciali in famiglia o tra amici.",
    "home.activities": "Esempi di attività per il vostro soggiorno franco-svizzero",
    "act.bike": "Mountain bike",
    "act.ski": "Sci",
    "act.snowshoe": "Racchette da neve",
    "act.hike": "Escursioni",
    "act.museum": "Musei dell'orologeria",
    "act.absinthe": "La strada dell'assenzio",
    "home.lodgings": "I nostri alloggi",
    "home.rentBoth": "Affittare i due alloggi contemporaneamente",
    "home.details": "Foto, informazioni e calendario",
    "home.detailsSoon": "Disponibile prossimamente · scopri di più",
    "unit.pers": "pers.",
    "unit.rooms": "cam.",
    "unit.baths": "bagno",
    "gite.loading": "Caricamento…",
    "gite.notfound": "Alloggio non trovato.",
    "gite.back": "Indietro",
    "gite.soonBadge": "Prossimamente",
    "gite.upcoming": "Prossimamente",
    "gite.giteFor": "Alloggio per {n} persone",
    "gite.bookThis": "Prenota questo alloggio",
    "gite.lodging": "L'alloggio",
    "gite.travelers": "{n} ospiti",
    "gite.bedsLine": "{r} camere · {b} letti",
    "gite.bathroom": "{n} bagno",
    "gite.amenities": "Servizi",
    "gite.good2know": "Buono a sapersi",
    "gite.gallery": "Galleria",
    "gite.galleryWait": "I lavori di allestimento sono in corso: le foto saranno pubblicate all'apertura.",
    "gite.availability": "Disponibilità e tariffe",
    "gite.calendar": "Calendario",
    "gite.from": "A partire da",
    "gite.perNight": " / notte",
    "gite.priceNote": "Tariffe secondo le date – consultate il calendario per il prezzo del vostro soggiorno. Pulizia obbligatoria: 40 € fino a 2 notti, 60 € da 3 notti.",
    "gite.rates": "Tariffe secondo le date",
    "book.cgvAccept": "Ho letto e accetto le condizioni generali di vendita e la politica di annullamento.",
    "book.cgvLink": "Condizioni di vendita",
    "book.cancelLink": "politica di annullamento",
    "book.cgvRequired": "Accettate le condizioni prima di continuare",
    "book.deposit": "Cauzione (preautorizzazione, senza addebito)",
    "book.recapTitle": "Da pagare alla conferma",
    "book.payObligation": "Continua verso il pagamento sicuro (obbligo di pagamento)",
    "gite.opening": "Apertura",
    "gite.soonAvailable": "Disponibile prossimamente",
    "gite.openNote": "Tariffe e foto saranno pubblicate all'apertura. Lasciateci la vostra email per essere avvisati in via prioritaria.",
    "gite.notifyMe": "Avvisami all'apertura",
    "gite.secure": "Pagamento sicuro con Stripe",
    "gite.towels": "Biancheria da bagno fornita",
    "gite.checkin": "Arrivo dalle 16 · partenza entro le 11",
    "gite.photoAlt": "Foto dell'alloggio",
    "book.eyebrow": "Prenotazione online",
    "book.title": "Scegliete le vostre date",
    "book.intro": "Le notti barrate sono già prenotate. La prenotazione non è immediata: confermiamo ogni richiesta entro 48 ore e il pagamento avviene in quel momento.",
    "book.sentTitle": "Richiesta inviata",
    "book.sentText": "Grazie! Vi reindirizziamo al pagamento sicuro Stripe per registrare la vostra carta. Nessun importo viene addebitato: confermiamo la richiesta entro 48 ore e solo allora l'importo viene incassato. In caso di rifiuto, la preautorizzazione è liberata immediatamente.",
    "book.details": "I vostri dati",
    "book.name": "Nome e cognome *",
    "book.email": "Email *",
    "book.phone": "Telefono",
    "book.guests": "Numero di persone *",
    "book.person": "persona",
    "book.persons": "persone",
    "book.adults": "Numero di persone maggiorenni *",
    "book.adultsNote": "Base di calcolo della tassa di soggiorno (minori esenti)",
    "book.adultsAuto": "Calcolato in base all'elenco degli ospiti qui sotto. Base di calcolo della tassa di soggiorno (minori esenti).",
    "book.purpose": "Motivo del soggiorno (facoltativo)",
    "book.firstName": "Nome *",
    "book.lastName": "Cognome *",
    "book.nationality": "Nazionalità *",
    "book.addr1": "Indirizzo *",
    "book.zip": "CAP *",
    "book.city": "Città *",
    "book.country": "Paese *",
    "book.holder": "Intestatario della prenotazione",
    "book.occupants": "Altri ospiti",
    "book.occupantsNote": "Cognome, nome, stato e nazionalità di ogni ospite accompagnatore, necessari per il contratto di locazione.",
    "book.occupant": "Ospite {n}",
    "book.adult": "Adulto",
    "book.minor": "Minore",
    "police.eyebrow": "Formalità di legge",
    "police.title": "Scheda individuale di polizia",
    "police.intro": "La normativa francese impone una scheda individuale per ogni ospite di nazionalità straniera alloggiato in una struttura turistica. Vi preghiamo di compilarla e firmarla il giorno del vostro arrivo.",
    "police.stay": "{g} · dal {a} al {d}",
    "police.lastName": "Cognome",
    "police.firstNames": "Nome/i",
    "police.birthDate": "Data di nascita",
    "police.birthPlace": "Luogo di nascita",
    "police.nationality": "Nazionalità",
    "police.home": "Residenza abituale",
    "police.mobile": "Telefono cellulare",
    "police.email": "Indirizzo email",
    "police.children": "Bambini sotto i 15 anni al seguito (nomi, facoltativo)",
    "police.signature": "Firma",
    "police.clear": "Cancella",
    "police.needSignature": "Firmate prima di inviare la scheda",
    "police.saved": "Scheda registrata. Grazie!",
    "police.error": "Salvataggio non riuscito, riprovate",
    "police.unknown": "Questa scheda non è più disponibile",
    "police.done": "Firmata",
    "police.fill": "Compila",
    "police.send": "Invia la scheda",
    "police.saving": "Salvataggio…",
    "police.back": "Indietro",
    "police.none": "Per questo soggiorno non è richiesta alcuna scheda.",
    "police.privacy": "Questi dati sono raccolti per adempiere a un obbligo di legge, conservati 6 mesi e poi cancellati automaticamente, e comunicati unicamente alla polizia o alla gendarmeria su loro richiesta.",
    "police.prepare": "Salva i miei dati",
    "police.prepareHint": "Può preparare i suoi dati fin d'ora: saranno conservati e le basterà firmare il giorno dell'arrivo, come previsto dalla normativa.",
    "police.draftSaved": "Dati salvati. Manca solo la firma, all'arrivo.",
    "police.prepared": "Preparata — da firmare all'arrivo",
    "police.continue": "Riprendi e firma",
    "faq.title": "Domande frequenti",
    "faq.q1": "Dove si trova La Ferme Comtoise?",
    "faq.a1": "In 2 rue de la Gypserie, 25500 Les Fins, nel Haut-Doubs: a una decina di minuti da Morteau e un quarto d'ora dal confine svizzero.",
    "faq.q2": "Quante persone possono soggiornare nello Chalet?",
    "faq.a2": "Fino a 6 ospiti su 90 m²: due camere e tre letti (un letto queen size nella prima, due letti matrimoniali nella seconda).",
    "faq.q3": "Lo Chalet è classificato?",
    "faq.a3": "Sì, Le Chalet è un alloggio turistico classificato 4 stelle. La Ferme non ha alcuna classificazione ad oggi e non è ancora prenotabile.",
    "faq.q4": "Si può prenotare direttamente sul sito?",
    "faq.a4": "Sì. La vostra richiesta non è una prenotazione definitiva: la carta viene solo preautorizzata, senza addebito. Rispondiamo entro 48 ore e l'importo viene incassato solo dopo la nostra conferma.",
    "faq.q5": "Quali sono gli orari di arrivo e partenza?",
    "faq.a5": "Arrivo dalle 16 e partenza entro le 11.",
    "faq.q6": "Biancheria da letto e asciugamani sono forniti?",
    "faq.a6": "Gli asciugamani sono forniti e i letti sono preparati prima del vostro arrivo. Alla partenza vi chiediamo soltanto di disfare i letti utilizzati e di lasciare gli asciugamani usati nella vasca.",
    "faq.q7": "A quanto ammontano le spese di pulizia?",
    "faq.a7": "40 € per un soggiorno di 1 o 2 notti e 60 € da 3 notti. La pulizia finale normale è a nostro carico e compresa in tale importo.",
    "faq.q8": "Come funziona la cauzione di 350 €?",
    "faq.a8": "Si tratta di una preautorizzazione, senza addebito. Può essere prelevata, in tutto o in parte, solo fino a 7 giorni dopo la partenza e unicamente con giustificazione scritta. In assenza di incidenti non viene effettuato alcun addebito.",
    "faq.q9": "Sono ammessi gli animali?",
    "faq.a9": "No, gli animali non sono ammessi. L'alloggio è per non fumatori, feste e party sono vietati e si richiede silenzio dopo le 22.",
    "faq.q10": "C'è un parcheggio e un accesso autonomo?",
    "faq.a10": "Sì: due posti auto gratuiti ai piedi della casa e accesso autonomo tramite cassetta di sicurezza per le chiavi, il cui codice vi viene inviato per email prima dell'arrivo.",
    "faq.q11": "Quali sono le condizioni di annullamento?",
    "faq.a11": "Rimborso del 100 % a più di 14 giorni dall'arrivo, del 50 % del prezzo del soggiorno da 14 a 7 giorni (estremi inclusi), nessun rimborso a meno di 7 giorni. Ogni annullamento deve essere inviato per iscritto a contact@lafermecomtoise.com.",
    "book.message": "Messaggio (raccontateci il vostro soggiorno)",
    "book.submit": "Invia la mia richiesta di prenotazione",
    "book.sending": "Invio della richiesta…",
    "book.legal": "Nessun addebito prima della nostra conferma: la carta è solo preautorizzata. Confermiamo entro 48 h; l'importo viene incassato solo allora e la preautorizzazione è liberata in caso di rifiuto.",
    "rev.source": "Recensione pubblicata inizialmente su {s}",
    "book.stay": "Il vostro soggiorno",
    "book.arrival": "Arrivo",
    "book.departure": "Partenza",
    "book.nights": "notti",
    "book.cleaning": "Spese di pulizia",
    "book.tax": "Tassa di soggiorno",
    "book.taxLine": "{r} € × {g} pers. × {n} notti",
    "book.total": "Totale",
    "book.taxNote": "Tassa di soggiorno di {r} € per notte e per persona maggiorenne, riscossa per conto di {c}. Pulizia obbligatoria: 40 € fino a 2 notti, 60 € da 3 notti. Cauzione di {d} tramite preautorizzazione sulla carta, senza addebito, prelevabile fino a 7 giorni dopo la partenza con giustificazione (vedi le ",
    "book.taxNoteCgv": "condizioni generali",
    "book.pickDates": "Selezionate una data di arrivo e poi di partenza nel calendario.",
    "book.errNoDates": "Scegliete prima le vostre date",
    "book.toastSent": "Richiesta inviata! Risposta entro 48 ore.",
    "purpose.holiday": "Vacanze",
    "purpose.family": "Weekend in famiglia",
    "purpose.friends": "Soggiorno tra amici",
    "purpose.work": "Viaggio di lavoro",
    "purpose.ski": "Sci / sport invernali",
    "purpose.event": "Evento di famiglia",
    "purpose.other": "Altro",
    "rev.eyebrow": "Esperienze",
    "rev.title": "Cosa dicono i nostri ospiti",
    "rev.emptyTitle": "Le prime recensioni stanno arrivando",
    "rev.emptyText": "La Ferme Comtoise ha appena aperto le porte. I nostri primi ospiti soggiornano in questo momento: i loro commenti saranno pubblicati qui, senza filtri.",
    "rev.ctaTitle": "Avete soggiornato da noi?",
    "rev.ctaText": "Scriveteci, pubblicheremo il vostro commento così com'è.",
    "rev.cta": "Lascia una recensione",
    "revf.eyebrow": "Il vostro soggiorno",
    "revf.title": "Lasciate la vostra recensione",
    "revf.intro": "Bastano poche righe. La vostra recensione sarà pubblicata dopo l'approvazione dei proprietari.",
    "revf.author": "Il vostro nome *",
    "revf.city": "Città",
    "revf.rating": "Voto",
    "revf.star": "stella",
    "revf.stars": "stelle",
    "revf.text": "La vostra recensione *",
    "revf.submit": "Invia la mia recensione",
    "revf.thanks": "Grazie!",
    "revf.thanksText": "La vostra recensione è stata inviata. Sarà pubblicata sul sito dopo la nostra lettura.",
    "revf.home": "Torna alla home",
    "ct.eyebrow": "Scriveteci",
    "ct.title1": "Una domanda?",
    "ct.title2": "Un soggiorno di gruppo?",
    "ct.intro": "Rispondiamo personalmente a ogni messaggio, di solito entro la giornata.",
    "ct.name": "Nome *",
    "ct.email": "Email *",
    "ct.phone": "Telefono",
    "ct.subject": "Oggetto",
    "ct.message": "Messaggio *",
    "ct.send": "Invia il messaggio",
    "ct.sending": "Invio…",
    "ct.success": "Grazie! Il vostro messaggio è arrivato.",
    "ct.toast": "Messaggio inviato! Rispondiamo entro 24 h.",
    "ct.address": "Indirizzo",
    "ct.emailLabel": "Email",
    "ct.checkinout": "Arrivo / partenza",
    "ct.checkinoutValue": "Arrivo dalle 16 · partenza entro le 11",
    "ct.map": "Mappa di Les Fins",
    "subj.info": "Richiesta di informazioni",
    "subj.group": "Prenotazione di gruppo (10 persone)",
    "subj.avail": "Disponibilità",
    "subj.review": "Lasciare una recensione",
    "subj.other": "Altro",
    "legal.eyebrow": "Informazioni legali",
  },
};

/** Traduction des phrases issues de la base (équipements, règles, avis, sous-titres). */
const PHRASES = {
  en: {
    "Gîte 4★ · 6 personnes": "4★ lodging · 6 guests",
    "Gîte 4 personnes · ouverture prochaine": "Lodging for 4 · opening soon",
    "Gîte 4 personnes · prochainement": "Lodging for 4 · coming soon",
    "Nos deux gîtes · 10 personnes": "Both lodgings · 10 guests",
    "Gîte classé meublé de tourisme 4★": "4★ classified holiday rental",
    "Chambre 1 : lit queen size": "Bedroom 1: queen-size bed",
    "Chambre 2 : deux lits doubles": "Bedroom 2: two double beds",
    "Chambre : lit queen size": "Bedroom: queen-size bed",
    "Canapé convertible": "Sofa bed",
    "Wifi rapide 65 Mbit/s": "Fast Wi-Fi 65 Mbit/s",
    "Wifi rapide": "Fast Wi-Fi",
    "Cuisine entièrement équipée": "Fully equipped kitchen",
    "Cuisine équipée": "Equipped kitchen",
    "Centrale de refroidissement": "Cooling system",
    "Baignoire": "Bathtub",
    "WC séparés": "Separate WC",
    "Lave-linge": "Washing machine",
    "Sèche-linge": "Tumble dryer",
    "Télévision": "Television",
    "Appareil à raclette": "Raclette grill",
    "Appareil à fondue": "Fondue set",
    "Linge de toilette fourni": "Towels provided",
    "Lit bébé et matelas à langer sur demande": "Cot and changing mat on request",
    "2 places de parking": "2 parking spaces",
    "1 place de parking": "1 parking space",
    "3 places de parking": "3 parking spaces",
    "Boîte à clés sécurisée": "Secure key box",
    "3 chambres, 4 lits et un canapé convertible": "3 bedrooms, 4 beds and a sofa bed",
    "2 cuisines équipées": "2 equipped kitchens",
    "2 salles de bain": "2 bathrooms",
    "2 WC séparés": "2 separate WCs",
    "2 lits bébé et 2 matelas à langer sur demande": "2 cots and 2 changing mats on request",
    "2 appareils à raclette": "2 raclette grills",
    "2 appareils à fondue": "2 fondue sets",
    "Arrivée à partir de 16 h": "Check-in from 4 pm",
    "Départ avant 11 h": "Check-out before 11 am",
    "Jusqu'à 6 voyageurs": "Up to 6 guests",
    "Jusqu'à 4 voyageurs": "Up to 4 guests",
    "Jusqu'à 10 voyageurs": "Up to 10 guests",
    "Animaux non acceptés": "No pets allowed",
    "Non-fumeur": "Non-smoking",
    "Respect du calme après 22 h": "Quiet hours after 10 pm",
    "Fêtes et soirées interdites": "No parties or events",
    "Détecteur de fumée": "Smoke detector",
    "Détecteurs de fumée": "Smoke detectors",
    "À venir": "Coming soon",
    "À venir.": "Coming soon.",
    "Réservez nos deux appartements en même temps pour une capacité totale de 10 personnes.":
      "Book both apartments at the same time for a total capacity of 10 guests.",
    "Vous pouvez louer les deux appartements pour obtenir une capacité allant jusqu'à 10 personnes, idéal pour les réunions de famille ou les week-ends entre amis.":
      "You can rent both apartments for a capacity of up to 10 guests — ideal for family gatherings or weekends with friends.",
    "Entrez dans un univers où le bois, la chaleur et l'esprit montagne vous enveloppent dès les premiers instants. Inspiré des chalets traditionnels, ce gîte a été décoré avec une attention particulière portée à chaque détail. Le bois omniprésent lui confère une atmosphère chaleureuse et intemporelle, tandis que les nombreux éléments décoratifs renforcent cette sensation d'évasion. Un lieu où l'on vient autant pour séjourner que pour vivre pleinement l'expérience d'un chalet au cœur du Haut-Doubs.":
      "Step into a world where wood, warmth and mountain spirit wrap around you from the very first moment. Inspired by traditional chalets, this lodging has been decorated with close attention to every detail. The omnipresent wood gives it a warm, timeless atmosphere, while the many decorative touches heighten the feeling of escape. A place you come to as much for the stay as for the full experience of a chalet in the heart of the Haut-Doubs.",
    "La petite famille de ma sœur a passé un agréable week-end dans ce magnifique appartement ! Le charme montagnard est là, tout a été rénové avec goût. Des recommandations à la réactivité des hôtes ou encore leur grande gentillesse, ils ont été conquis !":
      "My sister's little family spent a lovely weekend in this beautiful apartment! The mountain charm is there and everything has been tastefully renovated. From the recommendations to the hosts' quick replies and great kindness, they were won over!",
    "Waouh, quel bel appartement ! Nous avons fait tout notre possible pour séjourner ici et il a complètement dépassé nos attentes. La décoration est magnifique, tout semble de grande qualité, et l'appartement était impeccablement propre et très confortable. L'arrivée s'est déroulée sans problème et la communication avec les hôtes a été simple et conviviale.":
      "Wow, what a beautiful apartment! We did everything we could to stay here and it completely exceeded our expectations. The decoration is gorgeous, everything feels high quality, and the apartment was spotlessly clean and very comfortable. Check-in went smoothly and communication with the hosts was easy and friendly.",
    "Marie est une hôte très réactive, arrangeante et fort sympathique. Le logement est calme, neuf et surtout extrêmement bien entretenu. On s'y sent vraiment bien, comme à la maison. Si vous cherchez un endroit reposant pour vous et votre famille, n'hésitez surtout pas !":
      "Marie is a very responsive, accommodating and extremely friendly host. The place is quiet, brand new and above all extremely well kept. You really feel good there, just like home. If you are looking for a restful place for you and your family, do not hesitate!",
    "Tout était parfait : logement impeccable, nous avons beaucoup apprécié la décoration, à la fois soignée, très cosy et pleine de goût. Confortable et conforme à nos attentes. Très bonne communication et accueil au top. Nous reviendrons avec plaisir !":
      "Everything was perfect: an immaculate place, and we really loved the decoration — polished, very cosy and full of taste. Comfortable and just as described. Excellent communication and a wonderful welcome. We will gladly come back!",
  },
  de: {
    "Gîte 4★ · 6 personnes": "4★ Wohnung · 6 Personen",
    "Gîte 4 personnes · ouverture prochaine": "Wohnung für 4 · Eröffnung bald",
    "Gîte 4 personnes · prochainement": "Wohnung für 4 · demnächst",
    "Nos deux gîtes · 10 personnes": "Beide Wohnungen · 10 Personen",
    "Gîte classé meublé de tourisme 4★": "Mit 4★ klassifizierte Ferienwohnung",
    "Chambre 1 : lit queen size": "Schlafzimmer 1: Queensize-Bett",
    "Chambre 2 : deux lits doubles": "Schlafzimmer 2: zwei Doppelbetten",
    "Chambre : lit queen size": "Schlafzimmer: Queensize-Bett",
    "Canapé convertible": "Schlafsofa",
    "Wifi rapide 65 Mbit/s": "Schnelles WLAN 65 Mbit/s",
    "Wifi rapide": "Schnelles WLAN",
    "Cuisine entièrement équipée": "Voll ausgestattete Küche",
    "Cuisine équipée": "Ausgestattete Küche",
    "Centrale de refroidissement": "Kühlanlage",
    "Baignoire": "Badewanne",
    "WC séparés": "Separates WC",
    "Lave-linge": "Waschmaschine",
    "Sèche-linge": "Wäschetrockner",
    "Télévision": "Fernseher",
    "Appareil à raclette": "Raclette-Gerät",
    "Appareil à fondue": "Fondue-Set",
    "Linge de toilette fourni": "Handtücher inklusive",
    "Lit bébé et matelas à langer sur demande": "Babybett und Wickelauflage auf Anfrage",
    "2 places de parking": "2 Parkplätze",
    "1 place de parking": "1 Parkplatz",
    "3 places de parking": "3 Parkplätze",
    "Boîte à clés sécurisée": "Sicherer Schlüsselkasten",
    "3 chambres, 4 lits et un canapé convertible": "3 Schlafzimmer, 4 Betten und ein Schlafsofa",
    "2 cuisines équipées": "2 ausgestattete Küchen",
    "2 salles de bain": "2 Badezimmer",
    "2 WC séparés": "2 separate WCs",
    "2 lits bébé et 2 matelas à langer sur demande": "2 Babybetten und 2 Wickelauflagen auf Anfrage",
    "2 appareils à raclette": "2 Raclette-Geräte",
    "2 appareils à fondue": "2 Fondue-Sets",
    "Arrivée à partir de 16 h": "Anreise ab 16 Uhr",
    "Départ avant 11 h": "Abreise bis 11 Uhr",
    "Jusqu'à 6 voyageurs": "Bis zu 6 Gäste",
    "Jusqu'à 4 voyageurs": "Bis zu 4 Gäste",
    "Jusqu'à 10 voyageurs": "Bis zu 10 Gäste",
    "Animaux non acceptés": "Keine Haustiere",
    "Non-fumeur": "Nichtraucher",
    "Respect du calme après 22 h": "Ruhezeit ab 22 Uhr",
    "Fêtes et soirées interdites": "Partys und Feiern nicht erlaubt",
    "Détecteur de fumée": "Rauchmelder",
    "Détecteurs de fumée": "Rauchmelder",
    "À venir": "Demnächst",
    "À venir.": "Demnächst.",
    "Réservez nos deux appartements en même temps pour une capacité totale de 10 personnes.":
      "Buchen Sie beide Wohnungen gleichzeitig für insgesamt 10 Personen.",
    "Vous pouvez louer les deux appartements pour obtenir une capacité allant jusqu'à 10 personnes, idéal pour les réunions de famille ou les week-ends entre amis.":
      "Sie können beide Wohnungen mieten und so bis zu 10 Personen unterbringen – ideal für Familientreffen oder Wochenenden mit Freunden.",
    "Entrez dans un univers où le bois, la chaleur et l'esprit montagne vous enveloppent dès les premiers instants. Inspiré des chalets traditionnels, ce gîte a été décoré avec une attention particulière portée à chaque détail. Le bois omniprésent lui confère une atmosphère chaleureuse et intemporelle, tandis que les nombreux éléments décoratifs renforcent cette sensation d'évasion. Un lieu où l'on vient autant pour séjourner que pour vivre pleinement l'expérience d'un chalet au cœur du Haut-Doubs.":
      "Betreten Sie eine Welt, in der Holz, Wärme und Bergluft Sie vom ersten Moment an umhüllen. Inspiriert von traditionellen Chalets wurde diese Wohnung mit besonderer Liebe zum Detail eingerichtet. Das allgegenwärtige Holz verleiht ihr eine warme, zeitlose Atmosphäre, während die vielen Dekorationselemente das Gefühl des Ausbruchs verstärken. Ein Ort, an den man kommt, um zu wohnen – und um das Chalet-Erlebnis im Herzen des Haut-Doubs voll auszukosten.",
    "La petite famille de ma sœur a passé un agréable week-end dans ce magnifique appartement ! Le charme montagnard est là, tout a été rénové avec goût. Des recommandations à la réactivité des hôtes ou encore leur grande gentillesse, ils ont été conquis !":
      "Die kleine Familie meiner Schwester hat ein wunderschönes Wochenende in dieser herrlichen Wohnung verbracht! Der Bergcharme ist da, alles wurde geschmackvoll renoviert. Von den Empfehlungen bis zur schnellen Reaktion und großen Freundlichkeit der Gastgeber – sie waren begeistert!",
    "Waouh, quel bel appartement ! Nous avons fait tout notre possible pour séjourner ici et il a complètement dépassé nos attentes. La décoration est magnifique, tout semble de grande qualité, et l'appartement était impeccablement propre et très confortable. L'arrivée s'est déroulée sans problème et la communication avec les hôtes a été simple et conviviale.":
      "Wow, was für eine schöne Wohnung! Wir haben alles versucht, um hier zu übernachten, und sie hat unsere Erwartungen völlig übertroffen. Die Einrichtung ist wunderschön, alles wirkt hochwertig, und die Wohnung war tadellos sauber und sehr komfortabel. Die Anreise verlief problemlos und die Kommunikation mit den Gastgebern war einfach und herzlich.",
    "Marie est une hôte très réactive, arrangeante et fort sympathique. Le logement est calme, neuf et surtout extrêmement bien entretenu. On s'y sent vraiment bien, comme à la maison. Si vous cherchez un endroit reposant pour vous et votre famille, n'hésitez surtout pas !":
      "Marie ist eine sehr reaktionsschnelle, entgegenkommende und ausgesprochen sympathische Gastgeberin. Die Wohnung ist ruhig, neu und vor allem äußerst gut gepflegt. Man fühlt sich wirklich wohl, wie zu Hause. Wenn Sie einen erholsamen Ort für sich und Ihre Familie suchen, zögern Sie nicht!",
    "Tout était parfait : logement impeccable, nous avons beaucoup apprécié la décoration, à la fois soignée, très cosy et pleine de goût. Confortable et conforme à nos attentes. Très bonne communication et accueil au top. Nous reviendrons avec plaisir !":
      "Alles war perfekt: eine tadellose Wohnung, und die Einrichtung hat uns sehr gefallen – sorgfältig, sehr gemütlich und geschmackvoll. Komfortabel und genau wie beschrieben. Sehr gute Kommunikation und ein toller Empfang. Wir kommen gerne wieder!",
  },
  es: {
    "Gîte 4★ · 6 personnes": "Alojamiento 4★ · 6 personas",
    "Gîte 4 personnes · ouverture prochaine": "Alojamiento para 4 · próxima apertura",
    "Gîte 4 personnes · prochainement": "Alojamiento para 4 · próximamente",
    "Nos deux gîtes · 10 personnes": "Los dos alojamientos · 10 personas",
    "Gîte classé meublé de tourisme 4★": "Alojamiento turístico clasificado 4★",
    "Chambre 1 : lit queen size": "Habitación 1: cama queen size",
    "Chambre 2 : deux lits doubles": "Habitación 2: dos camas dobles",
    "Chambre : lit queen size": "Habitación: cama queen size",
    "Canapé convertible": "Sofá cama",
    "Wifi rapide 65 Mbit/s": "Wifi rápido 65 Mbit/s",
    "Wifi rapide": "Wifi rápido",
    "Cuisine entièrement équipée": "Cocina totalmente equipada",
    "Cuisine équipée": "Cocina equipada",
    "Centrale de refroidissement": "Sistema de refrigeración",
    "Baignoire": "Bañera",
    "WC séparés": "WC independiente",
    "Lave-linge": "Lavadora",
    "Sèche-linge": "Secadora",
    "Télévision": "Televisión",
    "Appareil à raclette": "Aparato de raclette",
    "Appareil à fondue": "Aparato de fondue",
    "Linge de toilette fourni": "Toallas incluidas",
    "Lit bébé et matelas à langer sur demande": "Cuna y cambiador bajo petición",
    "2 places de parking": "2 plazas de aparcamiento",
    "1 place de parking": "1 plaza de aparcamiento",
    "3 places de parking": "3 plazas de aparcamiento",
    "Boîte à clés sécurisée": "Caja de llaves segura",
    "3 chambres, 4 lits et un canapé convertible": "3 habitaciones, 4 camas y un sofá cama",
    "2 cuisines équipées": "2 cocinas equipadas",
    "2 salles de bain": "2 baños",
    "2 WC séparés": "2 WC independientes",
    "2 lits bébé et 2 matelas à langer sur demande": "2 cunas y 2 cambiadores bajo petición",
    "2 appareils à raclette": "2 aparatos de raclette",
    "2 appareils à fondue": "2 aparatos de fondue",
    "Arrivée à partir de 16 h": "Llegada a partir de las 16 h",
    "Départ avant 11 h": "Salida antes de las 11 h",
    "Jusqu'à 6 voyageurs": "Hasta 6 viajeros",
    "Jusqu'à 4 voyageurs": "Hasta 4 viajeros",
    "Jusqu'à 10 voyageurs": "Hasta 10 viajeros",
    "Animaux non acceptés": "No se admiten animales",
    "Non-fumeur": "No fumadores",
    "Respect du calme après 22 h": "Silencio a partir de las 22 h",
    "Fêtes et soirées interdites": "Fiestas y celebraciones prohibidas",
    "Détecteur de fumée": "Detector de humo",
    "Détecteurs de fumée": "Detectores de humo",
    "À venir": "Próximamente",
    "À venir.": "Próximamente.",
    "Réservez nos deux appartements en même temps pour une capacité totale de 10 personnes.":
      "Reserve nuestros dos apartamentos a la vez para una capacidad total de 10 personas.",
    "Vous pouvez louer les deux appartements pour obtenir une capacité allant jusqu'à 10 personnes, idéal pour les réunions de famille ou les week-ends entre amis.":
      "Puede alquilar los dos apartamentos para una capacidad de hasta 10 personas, ideal para reuniones familiares o fines de semana con amigos.",
    "Entrez dans un univers où le bois, la chaleur et l'esprit montagne vous enveloppent dès les premiers instants. Inspiré des chalets traditionnels, ce gîte a été décoré avec une attention particulière portée à chaque détail. Le bois omniprésent lui confère une atmosphère chaleureuse et intemporelle, tandis que les nombreux éléments décoratifs renforcent cette sensation d'évasion. Un lieu où l'on vient autant pour séjourner que pour vivre pleinement l'expérience d'un chalet au cœur du Haut-Doubs.":
      "Entre en un universo donde la madera, el calor y el espíritu de montaña le envuelven desde el primer instante. Inspirado en los chalés tradicionales, este alojamiento ha sido decorado con especial atención a cada detalle. La madera omnipresente le da una atmósfera cálida y atemporal, mientras que los numerosos elementos decorativos refuerzan esa sensación de evasión. Un lugar al que se viene tanto para alojarse como para vivir plenamente la experiencia de un chalé en el corazón del Haut-Doubs.",
    "La petite famille de ma sœur a passé un agréable week-end dans ce magnifique appartement ! Le charme montagnard est là, tout a été rénové avec goût. Des recommandations à la réactivité des hôtes ou encore leur grande gentillesse, ils ont été conquis !":
      "¡La pequeña familia de mi hermana pasó un fin de semana encantador en este magnífico apartamento! El encanto de montaña está presente y todo ha sido renovado con buen gusto. Desde las recomendaciones hasta la rapidez de respuesta y la gran amabilidad de los anfitriones, quedaron conquistados.",
    "Waouh, quel bel appartement ! Nous avons fait tout notre possible pour séjourner ici et il a complètement dépassé nos attentes. La décoration est magnifique, tout semble de grande qualité, et l'appartement était impeccablement propre et très confortable. L'arrivée s'est déroulée sans problème et la communication avec les hôtes a été simple et conviviale.":
      "¡Vaya, qué apartamento tan bonito! Hicimos todo lo posible por alojarnos aquí y superó por completo nuestras expectativas. La decoración es magnífica, todo parece de gran calidad y el apartamento estaba impecablemente limpio y muy confortable. La llegada fue sin problemas y la comunicación con los anfitriones, sencilla y cordial.",
    "Marie est une hôte très réactive, arrangeante et fort sympathique. Le logement est calme, neuf et surtout extrêmement bien entretenu. On s'y sent vraiment bien, comme à la maison. Si vous cherchez un endroit reposant pour vous et votre famille, n'hésitez surtout pas !":
      "Marie es una anfitriona muy atenta, flexible y sumamente simpática. El alojamiento es tranquilo, nuevo y sobre todo extremadamente bien cuidado. Uno se siente realmente bien, como en casa. Si busca un lugar tranquilo para usted y su familia, ¡no lo dude!",
    "Tout était parfait : logement impeccable, nous avons beaucoup apprécié la décoration, à la fois soignée, très cosy et pleine de goût. Confortable et conforme à nos attentes. Très bonne communication et accueil au top. Nous reviendrons avec plaisir !":
      "Todo fue perfecto: alojamiento impecable y nos encantó la decoración, cuidada, muy acogedora y con mucho gusto. Confortable y tal como esperábamos. Muy buena comunicación y una acogida excelente. ¡Volveremos con mucho gusto!",
  },
  it: {
    "Gîte 4★ · 6 personnes": "Alloggio 4★ · 6 persone",
    "Gîte 4 personnes · ouverture prochaine": "Alloggio per 4 · apertura prossima",
    "Gîte 4 personnes · prochainement": "Alloggio per 4 · prossimamente",
    "Nos deux gîtes · 10 personnes": "I due alloggi · 10 persone",
    "Gîte classé meublé de tourisme 4★": "Alloggio turistico classificato 4★",
    "Chambre 1 : lit queen size": "Camera 1: letto queen size",
    "Chambre 2 : deux lits doubles": "Camera 2: due letti matrimoniali",
    "Chambre : lit queen size": "Camera: letto queen size",
    "Canapé convertible": "Divano letto",
    "Wifi rapide 65 Mbit/s": "Wi-Fi veloce 65 Mbit/s",
    "Wifi rapide": "Wi-Fi veloce",
    "Cuisine entièrement équipée": "Cucina completamente attrezzata",
    "Cuisine équipée": "Cucina attrezzata",
    "Centrale de refroidissement": "Impianto di raffrescamento",
    "Baignoire": "Vasca da bagno",
    "WC séparés": "WC separato",
    "Lave-linge": "Lavatrice",
    "Sèche-linge": "Asciugatrice",
    "Télévision": "Televisione",
    "Appareil à raclette": "Apparecchio per raclette",
    "Appareil à fondue": "Apparecchio per fondue",
    "Linge de toilette fourni": "Biancheria da bagno fornita",
    "Lit bébé et matelas à langer sur demande": "Lettino e fasciatoio su richiesta",
    "2 places de parking": "2 posti auto",
    "1 place de parking": "1 posto auto",
    "3 places de parking": "3 posti auto",
    "Boîte à clés sécurisée": "Cassetta di sicurezza per le chiavi",
    "3 chambres, 4 lits et un canapé convertible": "3 camere, 4 letti e un divano letto",
    "2 cuisines équipées": "2 cucine attrezzate",
    "2 salles de bain": "2 bagni",
    "2 WC séparés": "2 WC separati",
    "2 lits bébé et 2 matelas à langer sur demande": "2 lettini e 2 fasciatoi su richiesta",
    "2 appareils à raclette": "2 apparecchi per raclette",
    "2 appareils à fondue": "2 apparecchi per fondue",
    "Arrivée à partir de 16 h": "Arrivo dalle 16",
    "Départ avant 11 h": "Partenza entro le 11",
    "Jusqu'à 6 voyageurs": "Fino a 6 ospiti",
    "Jusqu'à 4 voyageurs": "Fino a 4 ospiti",
    "Jusqu'à 10 voyageurs": "Fino a 10 ospiti",
    "Animaux non acceptés": "Animali non ammessi",
    "Non-fumeur": "Non fumatori",
    "Respect du calme après 22 h": "Silenzio dopo le 22",
    "Fêtes et soirées interdites": "Feste e party vietati",
    "Détecteur de fumée": "Rilevatore di fumo",
    "Détecteurs de fumée": "Rilevatori di fumo",
    "À venir": "Prossimamente",
    "À venir.": "Prossimamente.",
    "Réservez nos deux appartements en même temps pour une capacité totale de 10 personnes.":
      "Prenotate i nostri due appartamenti contemporaneamente per una capacità totale di 10 persone.",
    "Vous pouvez louer les deux appartements pour obtenir une capacité allant jusqu'à 10 personnes, idéal pour les réunions de famille ou les week-ends entre amis.":
      "Potete affittare i due appartamenti per una capacità fino a 10 persone, ideale per riunioni di famiglia o weekend tra amici.",
    "Entrez dans un univers où le bois, la chaleur et l'esprit montagne vous enveloppent dès les premiers instants. Inspiré des chalets traditionnels, ce gîte a été décoré avec une attention particulière portée à chaque détail. Le bois omniprésent lui confère une atmosphère chaleureuse et intemporelle, tandis que les nombreux éléments décoratifs renforcent cette sensation d'évasion. Un lieu où l'on vient autant pour séjourner que pour vivre pleinement l'expérience d'un chalet au cœur du Haut-Doubs.":
      "Entrate in un universo dove il legno, il calore e lo spirito di montagna vi avvolgono dal primo istante. Ispirato agli chalet tradizionali, questo alloggio è stato arredato con particolare attenzione a ogni dettaglio. Il legno onnipresente gli conferisce un'atmosfera calda e intramontabile, mentre i numerosi elementi decorativi rafforzano la sensazione di evasione. Un luogo dove si viene tanto per soggiornare quanto per vivere appieno l'esperienza di uno chalet nel cuore del Haut-Doubs.",
    "La petite famille de ma sœur a passé un agréable week-end dans ce magnifique appartement ! Le charme montagnard est là, tout a été rénové avec goût. Des recommandations à la réactivité des hôtes ou encore leur grande gentillesse, ils ont été conquis !":
      "La famiglia di mia sorella ha passato un weekend splendido in questo magnifico appartamento! Il fascino di montagna c'è tutto e ogni cosa è stata ristrutturata con gusto. Dai consigli alla rapidità di risposta e alla grande gentilezza degli host, sono stati conquistati!",
    "Waouh, quel bel appartement ! Nous avons fait tout notre possible pour séjourner ici et il a complètement dépassé nos attentes. La décoration est magnifique, tout semble de grande qualité, et l'appartement était impeccablement propre et très confortable. L'arrivée s'est déroulée sans problème et la communication avec les hôtes a été simple et conviviale.":
      "Wow, che bell'appartamento! Abbiamo fatto il possibile per soggiornare qui e ha superato ogni nostra aspettativa. L'arredamento è magnifico, tutto sembra di grande qualità e l'appartamento era impeccabilmente pulito e molto confortevole. L'arrivo è stato semplice e la comunicazione con gli host facile e cordiale.",
    "Marie est une hôte très réactive, arrangeante et fort sympathique. Le logement est calme, neuf et surtout extrêmement bien entretenu. On s'y sent vraiment bien, comme à la maison. Si vous cherchez un endroit reposant pour vous et votre famille, n'hésitez surtout pas !":
      "Marie è un'host molto disponibile, flessibile e davvero simpatica. L'alloggio è tranquillo, nuovo e soprattutto tenuto in modo eccellente. Ci si sente davvero bene, come a casa. Se cercate un posto riposante per voi e la vostra famiglia, non esitate!",
    "Tout était parfait : logement impeccable, nous avons beaucoup apprécié la décoration, à la fois soignée, très cosy et pleine de goût. Confortable et conforme à nos attentes. Très bonne communication et accueil au top. Nous reviendrons avec plaisir !":
      "Tutto era perfetto: alloggio impeccabile e abbiamo molto apprezzato l'arredamento, curato, molto accogliente e di gusto. Confortevole e all'altezza delle aspettative. Comunicazione ottima e accoglienza top. Torneremo con piacere!",
  },
};

const LEGAL_TITLES = {
  fr: { "mentions-legales": "Mentions légales", cgv: "Conditions générales de vente", annulation: "Politique d'annulation", confidentialite: "Politique de confidentialité" },
  it: { "mentions-legales": "Note legali", cgv: "Condizioni generali di vendita", annulation: "Politica di cancellazione", confidentialite: "Informativa sulla privacy" },
  en: { "mentions-legales": "Legal notice", cgv: "Terms and conditions of sale", annulation: "Cancellation policy", confidentialite: "Privacy policy" },
  de: { "mentions-legales": "Impressum", cgv: "Allgemeine Geschäftsbedingungen", annulation: "Stornobedingungen", confidentialite: "Datenschutzerklärung" },
  es: { "mentions-legales": "Aviso legal", cgv: "Condiciones generales de venta", annulation: "Política de cancelación", confidentialite: "Política de privacidad" },
};

export const useLegalTitles = () => {
  const { lang } = useI18n();
  return LEGAL_TITLES[lang] || LEGAL_TITLES.fr;
};

export { LEGAL_TITLES };

const Ctx = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("site_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("site_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(() => {
    const tr = (key, vars) => {
      let v = UI[lang]?.[key] ?? UI.fr[key] ?? key;
      if (typeof v === "string" && vars)
        Object.entries(vars).forEach(([k, val]) => { v = v.replaceAll(`{${k}}`, val); });
      return v;
    };
    const tp = (s) => (lang === "fr" || !s ? s : PHRASES[lang]?.[s] ?? s);
    const tg = (g) =>
      lang === "fr"
        ? g
        : {
            ...g,
            subtitle: tp(g.subtitle),
            nav_note: tp(g.nav_note),
            hero_note: tp(g.hero_note),
            short: tp(g.short),
            description: tp(g.description),
            amenities: (g.amenities || []).map(tp),
            rules: (g.rules || []).map(tp),
          };
    return { lang, setLang, t: tr, tp, tg };
  }, [lang]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useI18n = () => useContext(Ctx);
